/*
  Diccionario de intenciones del buscador (bbx) — A Granel Madrid
  GENERADO por 01-Proyectos/BUSCADOR-BENEFICIOS-2026-07-28/build-diccionario.js
  No lo edites a mano: edita dicc/*.js y vuelve a ejecutar el build.

  Traduce lo que escribe una persona real a los tags canónicos del catálogo.
  Todo en minúsculas, SIN TILDES y sin ñ, porque el motor normaliza así antes
  de consultar: "sueño" -> "sueno", "estreñimiento" -> "estrenimiento".

  Cuando dos bloques definen la misma clave, se unen sus tags (más cobertura).

  Bloques: 00-semilla.js, 99-correcciones.js, cardio-belleza.js, depurativo-etapas.js, digestivo-energia.js, sueno-defensas.js
  1037 frases · 848 palabras
*/
window.BBX_DICC = {
  frases: {
 "accion antibacteriana": [
  "bf-antibacteriano"
 ],
 "acelerar el metabolismo": [
  "bf-metabolismo",
  "yodo"
 ],
 "acidez de estomago": [
  "bf-acidez"
 ],
 "acidez estomacal": [
  "bf-acidez"
 ],
 "acido en la garganta": [
  "bf-acidez"
 ],
 "acido folico para el embarazo": [
  "bf-embarazo",
  "vitamina-b9"
 ],
 "acumulo liquidos": [
  "bf-diuretico"
 ],
 "afrodisiaco natural": [
  "bf-libido"
 ],
 "aftas bucales": [
  "bf-antibacteriano"
 ],
 "agilidad mental": [
  "bf-concentracion"
 ],
 "agobio constante": [
  "bf-relax"
 ],
 "aguantar mas en el gimnasio": [
  "bf-deporte"
 ],
 "alternativa al cafe": [
  "bf-estimulante"
 ],
 "alternativa sin cafeina al cafe": [
  "bf-sin-cafeina"
 ],
 "altibajos emocionales": [
  "bf-animo"
 ],
 "animo bajo": [
  "bf-animo"
 ],
 "animo decaido": [
  "bf-animo"
 ],
 "animo por los suelos": [
  "bf-animo"
 ],
 "ansiedad con la comida": [
  "bf-saciedad"
 ],
 "ansiedad por comer": [
  "bf-saciedad"
 ],
 "ansiedad por el dulce": [
  "bf-glucosa",
  "bf-saciedad"
 ],
 "antes de entrenar": [
  "bf-deporte"
 ],
 "antes del entrenamiento": [
  "bf-deporte"
 ],
 "antibacteriano natural": [
  "bf-antibacteriano"
 ],
 "antiinflamatorio natural": [
  "bf-antiinflamatorio",
  "omega-3"
 ],
 "antiseptico natural": [
  "bf-antibacteriano"
 ],
 "antojo de dulce": [
  "bf-glucosa"
 ],
 "antojos de dulce por la tarde": [
  "bf-glucosa"
 ],
 "aparato digestivo": [
  "bf-digestion"
 ],
 "aparato respiratorio": [
  "bf-respiratorio"
 ],
 "apatia emocional": [
  "bf-animo"
 ],
 "apto en el embarazo": [
  "bf-embarazo"
 ],
 "apto para embarazadas": [
  "bf-embarazo"
 ],
 "apto para ninos": [
  "bf-infantil"
 ],
 "arana vascular": [
  "bf-circulacion"
 ],
 "ardor de estomago": [
  "bf-acidez"
 ],
 "ardor despues de comer": [
  "bf-acidez"
 ],
 "arenilla en el rinon": [
  "bf-vias-urinarias"
 ],
 "arritmia cardiaca": [
  "bf-corazon"
 ],
 "arrugas en la cara": [
  "bf-antiedad"
 ],
 "articulaciones rigidas": [
  "bf-articulaciones"
 ],
 "artrosis de rodilla": [
  "bf-articulaciones"
 ],
 "astenia primaveral": [
  "bf-energia"
 ],
 "ataques de ansiedad": [
  "bf-relax"
 ],
 "aumento de peso en la menopausia": [
  "bf-menopausia"
 ],
 "ayuda para dormir": [
  "bf-sueno"
 ],
 "ayuda para la digestion": [
  "bf-digestion"
 ],
 "azucar alta": [
  "bf-glucosa"
 ],
 "azucar en sangre": [
  "bf-glucosa"
 ],
 "bajada de azucar": [
  "bf-glucosa"
 ],
 "bajada de defensas": [
  "bf-defensas"
 ],
 "bajar la tension": [
  "bf-tension",
  "potasio"
 ],
 "bajar la tripa": [
  "bf-metabolismo"
 ],
 "bajar los trigliceridos": [
  "bf-colesterol"
 ],
 "bajo deseo sexual": [
  "bf-libido"
 ],
 "bajon de animo": [
  "bf-animo"
 ],
 "barriga cervecera": [
  "bf-metabolismo"
 ],
 "barriga hinchada": [
  "bf-gases"
 ],
 "barriga inflada": [
  "bf-gases"
 ],
 "bichos buenos del intestino": [
  "bf-microbiota"
 ],
 "boca seca todo el dia": [
  "bf-hidratacion"
 ],
 "bronquios cargados": [
  "bf-respiratorio"
 ],
 "busco embarazo": [
  "bf-embarazo"
 ],
 "cabello debilitado": [
  "bf-pelo-unas"
 ],
 "cabeza espesa": [
  "bf-concentracion"
 ],
 "cabeza que no para de pensar": [
  "bf-relax"
 ],
 "caida de defensas": [
  "bf-defensas"
 ],
 "caida de pelo por la tiroides": [
  "bf-tiroides"
 ],
 "caida del pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "caida estacional del cabello": [
  "bf-pelo-unas",
  "zinc"
 ],
 "calambres en las piernas": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "calambres menstruales": [
  "bf-menstruacion"
 ],
 "calambres musculares": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "calambres por la noche": [
  "bf-musculo",
  "magnesio"
 ],
 "calculos renales": [
  "bf-vias-urinarias"
 ],
 "calores repentinos": [
  "bf-menopausia"
 ],
 "cambio de turno laboral": [
  "bf-sueno"
 ],
 "cambios de humor": [
  "bf-animo"
 ],
 "cambios de humor antes de la regla": [
  "bf-menstruacion"
 ],
 "cambios de humor por la menopausia": [
  "bf-menopausia"
 ],
 "candidiasis intestinal": [
  "bf-microbiota"
 ],
 "cansancio cronico": [
  "bf-energia",
  "vitamina-b12"
 ],
 "cansancio de primavera": [
  "bf-energia"
 ],
 "cansancio fisico y mental": [
  "bf-energia"
 ],
 "cansancio ocular": [
  "bf-vista"
 ],
 "cansancio permanente": [
  "bf-energia"
 ],
 "cargada de estres": [
  "bf-relax"
 ],
 "cargado de estres": [
  "bf-relax"
 ],
 "carraspera constante": [
  "bf-respiratorio"
 ],
 "cartilago desgastado": [
  "bf-articulaciones"
 ],
 "chorro de orina debil": [
  "bf-prostata"
 ],
 "ciclo menstrual irregular": [
  "bf-menstruacion"
 ],
 "circulacion sanguinea": [
  "bf-circulacion"
 ],
 "cistitis de la luna de miel": [
  "bf-vias-urinarias"
 ],
 "cistitis de repeticion": [
  "bf-vias-urinarias"
 ],
 "cistitis despues de tener relaciones": [
  "bf-vias-urinarias"
 ],
 "cistitis recurrente": [
  "bf-vias-urinarias"
 ],
 "climaterio sintomas": [
  "bf-menopausia"
 ],
 "coger musculo": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "cojo la gripe todos los anos": [
  "bf-defensas"
 ],
 "cojo todos los virus": [
  "bf-defensas"
 ],
 "colageno para la piel": [
  "bf-piel",
  "vitamina-c"
 ],
 "colageno para las arrugas": [
  "bf-antiedad",
  "vitamina-c"
 ],
 "colesterol alto": [
  "bf-colesterol"
 ],
 "colesterol en la analitica": [
  "bf-colesterol"
 ],
 "colesterol hereditario": [
  "bf-colesterol"
 ],
 "colesterol ldl alto": [
  "bf-colesterol"
 ],
 "colesterol malo alto": [
  "bf-colesterol"
 ],
 "colesterol por las nubes": [
  "bf-colesterol"
 ],
 "colesterol y trigliceridos": [
  "bf-colesterol"
 ],
 "colicos menstruales": [
  "bf-menstruacion"
 ],
 "colon irritable": [
  "bf-microbiota"
 ],
 "combatir los radicales libres": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "comer entre horas": [
  "bf-saciedad"
 ],
 "complemento infantil": [
  "bf-infantil"
 ],
 "complemento para mayores": [
  "bf-senior"
 ],
 "concentracion para estudiar": [
  "bf-concentracion"
 ],
 "conciliar el sueno": [
  "bf-sueno"
 ],
 "congestion de pecho": [
  "bf-respiratorio"
 ],
 "congestion nasal": [
  "bf-respiratorio"
 ],
 "contracturas musculares": [
  "bf-musculo"
 ],
 "control de peso": [
  "bf-metabolismo"
 ],
 "controlar el apetito": [
  "bf-saciedad"
 ],
 "controlar el azucar": [
  "bf-glucosa"
 ],
 "controlar el colesterol": [
  "bf-colesterol"
 ],
 "controlar la presion arterial": [
  "bf-tension"
 ],
 "controlar la tension": [
  "bf-tension"
 ],
 "corazon acelerado": [
  "bf-corazon"
 ],
 "corazon cansado": [
  "bf-corazon"
 ],
 "corazon debil": [
  "bf-corazon"
 ],
 "corte de digestion": [
  "bf-digestion"
 ],
 "crisis de ansiedad": [
  "bf-relax"
 ],
 "crujido en las rodillas": [
  "bf-articulaciones"
 ],
 "cuerpo en tension todo el dia": [
  "bf-relax"
 ],
 "cuidar el corazon": [
  "bf-corazon",
  "omega-3"
 ],
 "cuidar el higado": [
  "bf-depurativo"
 ],
 "cuidar el sistema digestivo": [
  "bf-digestion"
 ],
 "cuidar la piel": [
  "bf-piel",
  "vitamina-c"
 ],
 "cuidar la tiroides": [
  "bf-tiroides"
 ],
 "cuidar la vista": [
  "bf-vista",
  "vitamina-a"
 ],
 "cura depurativa": [
  "bf-depurativo"
 ],
 "danio celular": [
  "bf-antioxidante"
 ],
 "danio de los radicales libres": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "dar vueltas en la cama": [
  "bf-sueno"
 ],
 "debilidad muscular": [
  "bf-musculo"
 ],
 "defensas bajas": [
  "bf-defensas",
  "vitamina-c",
  "zinc"
 ],
 "defensas de los mayores": [
  "bf-senior",
  "bf-defensas"
 ],
 "defensas debilitadas": [
  "bf-defensas"
 ],
 "deficit de yodo": [
  "bf-tiroides",
  "yodo"
 ],
 "deposiciones dificiles": [
  "bf-transito"
 ],
 "desanimo total": [
  "bf-animo"
 ],
 "descafeinado natural": [
  "bf-sin-cafeina"
 ],
 "descalcificacion de los huesos": [
  "bf-huesos",
  "calcio"
 ],
 "descanso de calidad": [
  "bf-sueno"
 ],
 "descanso reparador": [
  "bf-sueno"
 ],
 "deseo sexual bajo": [
  "bf-libido"
 ],
 "desfase horario": [
  "bf-sueno"
 ],
 "desgaste articular": [
  "bf-articulaciones"
 ],
 "desinflamar el cuerpo": [
  "bf-antiinflamatorio"
 ],
 "despertar muy temprano sin motivo": [
  "bf-sueno"
 ],
 "despertares nocturnos": [
  "bf-sueno"
 ],
 "despues de comer mucho": [
  "bf-digestion"
 ],
 "despues de entrenar": [
  "bf-deporte",
  "bf-musculo"
 ],
 "despues de las fiestas": [
  "bf-depurativo"
 ],
 "despues de los excesos": [
  "bf-depurativo"
 ],
 "despues del entrenamiento": [
  "bf-deporte",
  "bf-musculo"
 ],
 "despues del parto": [
  "bf-embarazo"
 ],
 "diabetes tipo 2": [
  "bf-glucosa"
 ],
 "dieta depurativa": [
  "bf-depurativo"
 ],
 "dieta para adelgazar": [
  "bf-metabolismo"
 ],
 "dificultad para orinar en hombres": [
  "bf-prostata"
 ],
 "digestion lenta": [
  "bf-digestion"
 ],
 "digestion pesada": [
  "bf-digestion"
 ],
 "digestiones interminables": [
  "bf-digestion"
 ],
 "digestiones pesadas": [
  "bf-digestion"
 ],
 "digestiones pesadas por el higado": [
  "bf-depurativo"
 ],
 "disfuncion erectil": [
  "bf-libido"
 ],
 "dolor articular por la manana": [
  "bf-articulaciones"
 ],
 "dolor de agujetas": [
  "bf-musculo"
 ],
 "dolor de articulaciones": [
  "bf-articulaciones"
 ],
 "dolor de cabeza": [
  "bf-relax",
  "magnesio"
 ],
 "dolor de espalda y articulaciones": [
  "bf-articulaciones"
 ],
 "dolor de garganta": [
  "bf-respiratorio"
 ],
 "dolor de rinones": [
  "bf-vias-urinarias"
 ],
 "dolor de rodilla al bajar escaleras": [
  "bf-articulaciones"
 ],
 "dolor de rodillas": [
  "bf-articulaciones"
 ],
 "dolor de rodillas al subir escaleras": [
  "bf-articulaciones"
 ],
 "dolor en las manos por la manana": [
  "bf-articulaciones"
 ],
 "dolor en las rodillas": [
  "bf-articulaciones"
 ],
 "dolor inflamatorio": [
  "bf-antiinflamatorio"
 ],
 "dolor menstrual": [
  "bf-menstruacion"
 ],
 "dolor muscular": [
  "bf-musculo"
 ],
 "dolores de regla": [
  "bf-menstruacion"
 ],
 "dolores por inflamacion": [
  "bf-antiinflamatorio"
 ],
 "dormir mejor": [
  "bf-sueno"
 ],
 "duermo fatal": [
  "bf-sueno"
 ],
 "duermo mal": [
  "bf-sueno"
 ],
 "eccema en la piel": [
  "bf-piel"
 ],
 "edema en las piernas": [
  "bf-diuretico"
 ],
 "edema en los tobillos": [
  "bf-diuretico"
 ],
 "efecto antioxidante": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "efecto drenante para las piernas": [
  "bf-diuretico"
 ],
 "efecto rebote": [
  "bf-metabolismo"
 ],
 "eliminar toxinas del cuerpo": [
  "bf-depurativo"
 ],
 "endurecimiento de las arterias": [
  "bf-circulacion",
  "bf-corazon"
 ],
 "energia para entrenar": [
  "bf-deporte",
  "bf-energia"
 ],
 "entreno fuerte": [
  "bf-deporte"
 ],
 "envejecimiento de la piel": [
  "bf-antiedad",
  "bf-piel"
 ],
 "envejecimiento prematuro": [
  "bf-antiedad"
 ],
 "epoca de examenes": [
  "bf-concentracion"
 ],
 "epoca de resfriados": [
  "bf-defensas"
 ],
 "equilibrio de la flora": [
  "bf-microbiota"
 ],
 "estado de animo bajo": [
  "bf-animo"
 ],
 "estomago pesado": [
  "bf-digestion"
 ],
 "estomago revuelto": [
  "bf-digestion",
  "bf-nauseas"
 ],
 "estoy agotada": [
  "bf-energia"
 ],
 "estoy agotado": [
  "bf-energia"
 ],
 "estoy cansada": [
  "bf-energia",
  "hierro"
 ],
 "estoy cansada todo el dia": [
  "bf-energia"
 ],
 "estoy cansado": [
  "bf-energia",
  "hierro"
 ],
 "estoy cansado todo el dia": [
  "bf-energia"
 ],
 "estoy dando el pecho": [
  "bf-embarazo"
 ],
 "estoy de bajon": [
  "bf-animo"
 ],
 "estoy embarazada": [
  "bf-embarazo"
 ],
 "estoy en la menopausia": [
  "bf-menopausia"
 ],
 "estoy en periodo de lactancia": [
  "bf-embarazo"
 ],
 "estoy estrenida": [
  "bf-transito"
 ],
 "estoy estrenido": [
  "bf-transito"
 ],
 "estoy estresada": [
  "bf-relax"
 ],
 "estoy estresado": [
  "bf-relax"
 ],
 "estoy muy nerviosa": [
  "bf-relax"
 ],
 "estoy muy nervioso": [
  "bf-relax"
 ],
 "estoy muy tensa": [
  "bf-relax"
 ],
 "estoy muy tenso": [
  "bf-relax"
 ],
 "estoy pillando algo": [
  "bf-defensas"
 ],
 "estoy sin fuerzas": [
  "bf-energia"
 ],
 "estrenimiento cronico": [
  "bf-transito"
 ],
 "estres cronico": [
  "bf-relax"
 ],
 "estres laboral": [
  "bf-relax"
 ],
 "estres oxidativo": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "exceso de comidas y alcohol": [
  "bf-depurativo"
 ],
 "exceso de gases": [
  "bf-gases"
 ],
 "exceso de grasas y toxinas": [
  "bf-depurativo"
 ],
 "exceso de peso": [
  "bf-metabolismo"
 ],
 "expectorante natural": [
  "bf-respiratorio"
 ],
 "falta de agilidad mental": [
  "bf-concentracion"
 ],
 "falta de animo": [
  "bf-animo"
 ],
 "falta de concentracion": [
  "bf-concentracion"
 ],
 "falta de deseo": [
  "bf-libido"
 ],
 "falta de energia": [
  "bf-energia"
 ],
 "falta de firmeza en la piel": [
  "bf-antiedad",
  "bf-piel"
 ],
 "falta de libido": [
  "bf-libido"
 ],
 "falta de memoria": [
  "bf-concentracion"
 ],
 "falta de motivacion": [
  "bf-animo"
 ],
 "falta de sueno": [
  "bf-sueno"
 ],
 "falta de vitalidad": [
  "bf-energia"
 ],
 "falta de yodo": [
  "bf-tiroides",
  "yodo"
 ],
 "fatiga cronica": [
  "bf-energia",
  "vitamina-b12"
 ],
 "fatiga visual": [
  "bf-vista"
 ],
 "fertilidad femenina": [
  "bf-embarazo"
 ],
 "fitoestrogenos para la menopausia": [
  "bf-menopausia"
 ],
 "flacidez de la piel": [
  "bf-antiedad",
  "bf-piel"
 ],
 "flacidez muscular": [
  "bf-musculo"
 ],
 "flemas dificiles de expulsar": [
  "bf-respiratorio"
 ],
 "flora bacteriana": [
  "bf-microbiota"
 ],
 "flora intestinal": [
  "bf-microbiota"
 ],
 "flora intestinal danada": [
  "bf-microbiota"
 ],
 "fortalecer el corazon": [
  "bf-corazon"
 ],
 "fortalecer los huesos en la menopausia": [
  "bf-huesos",
  "calcio"
 ],
 "funcion tiroidea": [
  "bf-tiroides",
  "yodo"
 ],
 "ganas de vomitar": [
  "bf-nauseas"
 ],
 "ganas frecuentes de orinar": [
  "bf-vias-urinarias"
 ],
 "garganta irritada": [
  "bf-respiratorio"
 ],
 "gases y flatulencias": [
  "bf-gases"
 ],
 "glandula tiroides": [
  "bf-tiroides"
 ],
 "glucosa alta": [
  "bf-glucosa"
 ],
 "golpe de calor": [
  "bf-hidratacion"
 ],
 "goteo al terminar de orinar": [
  "bf-prostata"
 ],
 "granos en la cara": [
  "bf-piel"
 ],
 "grasa abdominal": [
  "bf-metabolismo"
 ],
 "grasa localizada": [
  "bf-metabolismo"
 ],
 "grasas en la sangre": [
  "bf-colesterol"
 ],
 "hacer un detox": [
  "bf-depurativo"
 ],
 "hacer una limpieza de higado": [
  "bf-depurativo"
 ],
 "hago mucho deporte": [
  "bf-deporte"
 ],
 "hambre constante": [
  "bf-saciedad"
 ],
 "heces duras": [
  "bf-transito"
 ],
 "hecha polvo": [
  "bf-energia"
 ],
 "hecho cisco": [
  "bf-energia"
 ],
 "hecho polvo": [
  "bf-energia"
 ],
 "hernia de hiato": [
  "bf-acidez"
 ],
 "hierba luisa": [
  "bf-relax"
 ],
 "higado cargado": [
  "bf-depurativo"
 ],
 "higado graso": [
  "bf-depurativo"
 ],
 "higado inflamado": [
  "bf-depurativo"
 ],
 "higado sobrecargado": [
  "bf-depurativo"
 ],
 "hinchazon abdominal": [
  "bf-gases"
 ],
 "hinchazon antes de la regla": [
  "bf-menstruacion",
  "bf-diuretico"
 ],
 "hinchazon de piernas al final del dia": [
  "bf-diuretico"
 ],
 "hinchazon despues de comer": [
  "bf-gases"
 ],
 "hinchazon en verano": [
  "bf-diuretico"
 ],
 "hinchazon por el calor": [
  "bf-diuretico"
 ],
 "hinchazon por liquidos": [
  "bf-diuretico"
 ],
 "hiperplasia prostatica": [
  "bf-prostata"
 ],
 "hipertension arterial": [
  "bf-tension"
 ],
 "hipertension arterial descontrolada": [
  "bf-tension"
 ],
 "hipotiroidismo subclinico": [
  "bf-tiroides",
  "yodo"
 ],
 "hormigueo en los pies": [
  "bf-circulacion"
 ],
 "hormonas tiroideas": [
  "bf-tiroides"
 ],
 "huesos debiles": [
  "bf-huesos",
  "calcio"
 ],
 "huesos en la menopausia": [
  "bf-huesos",
  "calcio"
 ],
 "huesos fragiles": [
  "bf-huesos"
 ],
 "huesos quebradizos": [
  "bf-huesos"
 ],
 "infeccion de orina": [
  "bf-vias-urinarias"
 ],
 "infeccion de vejiga": [
  "bf-vias-urinarias"
 ],
 "infeccion urinaria": [
  "bf-vias-urinarias"
 ],
 "inflamacion cronica": [
  "bf-antiinflamatorio"
 ],
 "inflamacion de bajo grado": [
  "bf-antiinflamatorio"
 ],
 "inflamacion en el cuerpo": [
  "bf-antiinflamatorio"
 ],
 "infusion sin teina": [
  "bf-sin-cafeina"
 ],
 "insomnio cronico": [
  "bf-sueno"
 ],
 "insomnio de la menopausia": [
  "bf-menopausia"
 ],
 "insuficiencia venosa": [
  "bf-circulacion"
 ],
 "intestino irregular": [
  "bf-transito"
 ],
 "intestino irritable": [
  "bf-microbiota"
 ],
 "intestino perezoso": [
  "bf-transito"
 ],
 "ir al bano": [
  "bf-transito",
  "fibra"
 ],
 "irritabilidad nerviosa": [
  "bf-relax"
 ],
 "jarabe para ninos": [
  "bf-infantil",
  "bf-respiratorio"
 ],
 "jet lag": [
  "bf-sueno"
 ],
 "las rodillas me duelen al andar": [
  "bf-articulaciones"
 ],
 "lavado de higado": [
  "bf-depurativo"
 ],
 "libre de cafeina": [
  "bf-sin-cafeina"
 ],
 "limpieza de higado": [
  "bf-depurativo"
 ],
 "limpieza hepatica": [
  "bf-depurativo"
 ],
 "lineas de expresion": [
  "bf-antiedad"
 ],
 "llagas en la boca": [
  "bf-antibacteriano"
 ],
 "llevo dias sin ir al bano": [
  "bf-transito"
 ],
 "mal cuerpo": [
  "bf-nauseas"
 ],
 "mal descanso nocturno": [
  "bf-sueno"
 ],
 "mal humor constante": [
  "bf-animo"
 ],
 "mala cara por el higado": [
  "bf-depurativo"
 ],
 "mala circulacion": [
  "bf-circulacion"
 ],
 "mala circulacion en las piernas": [
  "bf-circulacion"
 ],
 "mala digestion": [
  "bf-digestion"
 ],
 "mala memoria": [
  "bf-concentracion"
 ],
 "malas digestiones": [
  "bf-digestion"
 ],
 "malestar estomacal": [
  "bf-digestion"
 ],
 "manos frias": [
  "bf-circulacion"
 ],
 "mareo de barco": [
  "bf-nauseas"
 ],
 "mareo del coche": [
  "bf-nauseas"
 ],
 "mareo en barco": [
  "bf-nauseas"
 ],
 "mareo en el coche": [
  "bf-nauseas"
 ],
 "mareos del embarazo": [
  "bf-nauseas",
  "vitamina-b6"
 ],
 "masa muscular": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "me arde al orinar": [
  "bf-vias-urinarias"
 ],
 "me arde el estomago": [
  "bf-acidez"
 ],
 "me baja mucho la regla": [
  "bf-menstruacion"
 ],
 "me constipo mucho": [
  "bf-defensas"
 ],
 "me cuesta cogerle el sueno": [
  "bf-sueno"
 ],
 "me cuesta concentrarme": [
  "bf-concentracion"
 ],
 "me cuesta conciliar el sueno": [
  "bf-sueno"
 ],
 "me cuesta digerir": [
  "bf-digestion"
 ],
 "me cuesta dormir": [
  "bf-sueno"
 ],
 "me cuesta orinar": [
  "bf-prostata",
  "bf-vias-urinarias"
 ],
 "me dan calambres": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "me deshidrato facilmente": [
  "bf-hidratacion"
 ],
 "me despierto muy pronto": [
  "bf-sueno"
 ],
 "me despierto por la noche": [
  "bf-sueno"
 ],
 "me despierto varias veces por la noche": [
  "bf-sueno"
 ],
 "me duele al hacer pis": [
  "bf-vias-urinarias"
 ],
 "me duele la regla": [
  "bf-menstruacion"
 ],
 "me duelen las articulaciones": [
  "bf-articulaciones"
 ],
 "me duelen las rodillas": [
  "bf-articulaciones"
 ],
 "me duelen los musculos": [
  "bf-musculo"
 ],
 "me entra ansiedad por comer": [
  "bf-saciedad"
 ],
 "me escuece al hacer pis": [
  "bf-vias-urinarias"
 ],
 "me escuece al orinar": [
  "bf-vias-urinarias"
 ],
 "me falta energia": [
  "bf-energia"
 ],
 "me faltan las reglas": [
  "bf-menopausia"
 ],
 "me ha salido el colesterol alto": [
  "bf-colesterol"
 ],
 "me ha subido la tension": [
  "bf-tension"
 ],
 "me han salido agujetas": [
  "bf-musculo"
 ],
 "me hincho antes de la regla": [
  "bf-diuretico",
  "bf-menstruacion"
 ],
 "me hincho con la regla": [
  "bf-diuretico",
  "bf-menstruacion"
 ],
 "me levanto cansada": [
  "bf-energia"
 ],
 "me levanto cansado": [
  "bf-energia"
 ],
 "me levanto por la noche a orinar": [
  "bf-prostata"
 ],
 "me levanto varias veces a orinar": [
  "bf-prostata"
 ],
 "me mareo mucho": [
  "bf-nauseas"
 ],
 "me quede afonica": [
  "bf-respiratorio"
 ],
 "me quede afonico": [
  "bf-respiratorio"
 ],
 "me quedo dormido en el trabajo": [
  "bf-estimulante"
 ],
 "me repite la comida": [
  "bf-acidez"
 ],
 "me resfrio con facilidad": [
  "bf-defensas"
 ],
 "me sienta mal el alcohol": [
  "bf-depurativo"
 ],
 "me sienta mal todo lo que como": [
  "bf-digestion"
 ],
 "me siento agobiada": [
  "bf-relax"
 ],
 "me siento agobiado": [
  "bf-relax"
 ],
 "me siento hinchada": [
  "bf-gases"
 ],
 "me siento hinchado": [
  "bf-gases"
 ],
 "me siento intoxicada": [
  "bf-depurativo"
 ],
 "me siento intoxicado": [
  "bf-depurativo"
 ],
 "me siento pesada": [
  "bf-digestion"
 ],
 "me siento pesado": [
  "bf-digestion"
 ],
 "me siento sobrepasada": [
  "bf-relax"
 ],
 "me siento sobrepasado": [
  "bf-relax"
 ],
 "me siento triste": [
  "bf-animo"
 ],
 "me viene fatal la regla": [
  "bf-menstruacion"
 ],
 "mejorar el rendimiento fisico": [
  "bf-deporte"
 ],
 "mejorar el rendimiento sexual": [
  "bf-libido"
 ],
 "mejorar la circulacion": [
  "bf-circulacion"
 ],
 "melatonina para dormir": [
  "bf-sueno",
  "melatonina"
 ],
 "memoria a corto plazo": [
  "bf-concentracion"
 ],
 "memoria para estudiar": [
  "bf-concentracion"
 ],
 "mente acelerada por la noche": [
  "bf-sueno"
 ],
 "metabolismo lento": [
  "bf-metabolismo",
  "yodo"
 ],
 "mi bebe tiene mocos": [
  "bf-infantil",
  "bf-respiratorio"
 ],
 "mi hija esta acatarrada": [
  "bf-infantil",
  "bf-defensas"
 ],
 "mi hijo esta acatarrado": [
  "bf-infantil",
  "bf-defensas"
 ],
 "molestias al orinar": [
  "bf-vias-urinarias"
 ],
 "molestias de prostata": [
  "bf-prostata"
 ],
 "molestias digestivas": [
  "bf-digestion"
 ],
 "molestias en las articulaciones": [
  "bf-articulaciones"
 ],
 "molestias en las manos por la manana": [
  "bf-articulaciones"
 ],
 "mucha hambre": [
  "bf-saciedad"
 ],
 "mucho estres": [
  "bf-relax"
 ],
 "muchos eructos": [
  "bf-gases"
 ],
 "mucosidad constante": [
  "bf-respiratorio"
 ],
 "muerta de cansancio": [
  "bf-energia"
 ],
 "muerto de cansancio": [
  "bf-energia"
 ],
 "nariz taponada": [
  "bf-respiratorio"
 ],
 "nauseas del embarazo": [
  "bf-nauseas",
  "vitamina-b6"
 ],
 "nauseas del primer trimestre": [
  "bf-embarazo",
  "vitamina-b6"
 ],
 "nauseas matutinas": [
  "bf-nauseas",
  "vitamina-b6"
 ],
 "nauseas por la manana": [
  "bf-nauseas",
  "vitamina-b6"
 ],
 "nauseas y mareos": [
  "bf-nauseas"
 ],
 "necesito animarme": [
  "bf-animo"
 ],
 "necesito concentrarme para estudiar": [
  "bf-concentracion"
 ],
 "necesito depurar el cuerpo": [
  "bf-depurativo"
 ],
 "necesito desconectar": [
  "bf-relax"
 ],
 "necesito dormir bien": [
  "bf-sueno"
 ],
 "necesito eliminar liquidos": [
  "bf-diuretico"
 ],
 "necesito energia": [
  "bf-energia"
 ],
 "necesito espabilar": [
  "bf-estimulante"
 ],
 "necesito estar alerta": [
  "bf-estimulante"
 ],
 "necesito las pilas puestas": [
  "bf-energia"
 ],
 "necesito perder peso": [
  "bf-metabolismo"
 ],
 "necesito relajarme": [
  "bf-relax"
 ],
 "necesito reponer la flora": [
  "bf-microbiota"
 ],
 "necesito un chute de energia": [
  "bf-energia"
 ],
 "nervios antes de hablar en publico": [
  "bf-relax"
 ],
 "nervios antes de un examen": [
  "bf-relax"
 ],
 "niebla mental": [
  "bf-concentracion"
 ],
 "niveles de azucar": [
  "bf-glucosa"
 ],
 "no concilio el sueno": [
  "bf-sueno"
 ],
 "no consigo adelgazar": [
  "bf-metabolismo"
 ],
 "no consigo bajar de peso": [
  "bf-metabolismo"
 ],
 "no hago bien la digestion": [
  "bf-digestion"
 ],
 "no logro dormir": [
  "bf-sueno"
 ],
 "no me entra nada": [
  "bf-concentracion"
 ],
 "no me levanto con energia": [
  "bf-energia"
 ],
 "no me puedo concentrar": [
  "bf-concentracion"
 ],
 "no paro de darle vueltas a la cabeza": [
  "bf-relax"
 ],
 "no paro de picar": [
  "bf-saciedad"
 ],
 "no pego ojo": [
  "bf-sueno"
 ],
 "no pego ojo en toda la noche": [
  "bf-sueno"
 ],
 "no puedo dormir": [
  "bf-sueno"
 ],
 "no puedo hacer caca": [
  "bf-transito"
 ],
 "no puedo ir al bano": [
  "bf-transito"
 ],
 "no puedo relajarme": [
  "bf-relax"
 ],
 "no puedo respirar bien por la nariz": [
  "bf-respiratorio"
 ],
 "no quiero cafeina": [
  "bf-sin-cafeina"
 ],
 "no tengo energia": [
  "bf-energia"
 ],
 "no tengo fuerzas": [
  "bf-energia"
 ],
 "no tengo ganas de nada": [
  "bf-animo"
 ],
 "no voy al bano": [
  "bf-transito"
 ],
 "nodulos en la tiroides": [
  "bf-tiroides"
 ],
 "notar el corazon acelerado": [
  "bf-corazon"
 ],
 "nudo en el estomago por los nervios": [
  "bf-relax"
 ],
 "ojos cansados del ordenador": [
  "bf-vista"
 ],
 "ojos secos": [
  "bf-vista"
 ],
 "oleadas de calor": [
  "bf-menopausia"
 ],
 "orina con mal olor": [
  "bf-vias-urinarias"
 ],
 "orina turbia": [
  "bf-vias-urinarias"
 ],
 "orinar por la noche varias veces": [
  "bf-prostata"
 ],
 "orino con frecuencia": [
  "bf-vias-urinarias"
 ],
 "orino muy poco": [
  "bf-diuretico"
 ],
 "orino poco": [
  "bf-diuretico"
 ],
 "palpitaciones del corazon": [
  "bf-corazon"
 ],
 "para acelerar el metabolismo": [
  "bf-metabolismo",
  "yodo"
 ],
 "para activar la circulacion": [
  "bf-circulacion"
 ],
 "para activarme por la manana": [
  "bf-estimulante"
 ],
 "para adelantar la regla": [
  "bf-menstruacion"
 ],
 "para adelgazar": [
  "bf-metabolismo"
 ],
 "para aguantar mas entrenando": [
  "bf-deporte"
 ],
 "para aumentar la leche materna": [
  "bf-embarazo"
 ],
 "para aumentar la libido": [
  "bf-libido"
 ],
 "para bajar el colesterol": [
  "bf-colesterol",
  "fibra"
 ],
 "para bajar la inflamacion del cuerpo": [
  "bf-antiinflamatorio",
  "omega-3"
 ],
 "para beber mas agua": [
  "bf-hidratacion"
 ],
 "para bebes": [
  "bf-infantil"
 ],
 "para calmar los nervios": [
  "bf-relax"
 ],
 "para combatir el envejecimiento celular": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "para concentrarme": [
  "bf-concentracion"
 ],
 "para conciliar el sueno": [
  "bf-sueno"
 ],
 "para controlar el apetito": [
  "bf-saciedad"
 ],
 "para corredores": [
  "bf-deporte"
 ],
 "para correr": [
  "bf-deporte"
 ],
 "para cuidar el sistema cardiovascular": [
  "bf-corazon"
 ],
 "para cuidar la prostata": [
  "bf-prostata"
 ],
 "para deportistas": [
  "bf-deporte"
 ],
 "para depurar el organismo": [
  "bf-depurativo"
 ],
 "para descansar mejor por la noche": [
  "bf-sueno"
 ],
 "para desconectar": [
  "bf-relax"
 ],
 "para descongestionar": [
  "bf-respiratorio"
 ],
 "para deshinchar la tripa": [
  "bf-gases"
 ],
 "para desinfectar heridas": [
  "bf-antibacteriano"
 ],
 "para desinflamar": [
  "bf-antiinflamatorio"
 ],
 "para desinflamar la tripa": [
  "bf-gases"
 ],
 "para desinflamar las piernas": [
  "bf-diuretico"
 ],
 "para desintoxicar el cuerpo": [
  "bf-depurativo"
 ],
 "para despejarme": [
  "bf-estimulante"
 ],
 "para despues de antibioticos": [
  "bf-microbiota"
 ],
 "para despues de comidas copiosas": [
  "bf-digestion"
 ],
 "para despues de hacer deporte y sudar": [
  "bf-hidratacion"
 ],
 "para digerir mejor": [
  "bf-digestion"
 ],
 "para dormir": [
  "bf-sueno"
 ],
 "para dormir a los ninos": [
  "bf-infantil",
  "bf-sueno"
 ],
 "para dormir en la menopausia": [
  "bf-menopausia"
 ],
 "para dormir mejor": [
  "bf-sueno"
 ],
 "para drenar el cuerpo": [
  "bf-diuretico"
 ],
 "para el acne": [
  "bf-piel"
 ],
 "para el agotamiento": [
  "bf-energia"
 ],
 "para el antojo de dulce": [
  "bf-glucosa"
 ],
 "para el apetito sexual": [
  "bf-libido"
 ],
 "para el ardor de estomago": [
  "bf-acidez"
 ],
 "para el azucar": [
  "bf-glucosa"
 ],
 "para el bajon de la tarde": [
  "bf-estimulante"
 ],
 "para el bochorno": [
  "bf-menopausia"
 ],
 "para el calor y la deshidratacion": [
  "bf-hidratacion"
 ],
 "para el cambio de estacion": [
  "bf-defensas"
 ],
 "para el cansancio": [
  "bf-energia"
 ],
 "para el cerebro": [
  "bf-concentracion",
  "omega-3"
 ],
 "para el ciclismo": [
  "bf-deporte"
 ],
 "para el climaterio": [
  "bf-menopausia"
 ],
 "para el colesterol": [
  "bf-colesterol",
  "fibra"
 ],
 "para el colesterol y el corazon": [
  "bf-colesterol",
  "bf-corazon"
 ],
 "para el corazon": [
  "bf-corazon",
  "omega-3"
 ],
 "para el crossfit": [
  "bf-deporte"
 ],
 "para el deporte": [
  "bf-deporte"
 ],
 "para el desanimo": [
  "bf-animo"
 ],
 "para el descanso de los mayores": [
  "bf-senior",
  "bf-sueno"
 ],
 "para el deseo en la pareja": [
  "bf-libido"
 ],
 "para el deseo sexual": [
  "bf-libido"
 ],
 "para el dolor de regla": [
  "bf-menstruacion"
 ],
 "para el dolor de rodillas": [
  "bf-articulaciones"
 ],
 "para el efecto rebote": [
  "bf-metabolismo"
 ],
 "para el embarazo": [
  "bf-embarazo"
 ],
 "para el envejecimiento": [
  "bf-antiedad"
 ],
 "para el estrenimiento": [
  "bf-transito",
  "fibra"
 ],
 "para el estres": [
  "bf-relax"
 ],
 "para el estres oxidativo": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "para el gimnasio": [
  "bf-deporte"
 ],
 "para el golpe de calor": [
  "bf-hidratacion"
 ],
 "para el higado": [
  "bf-depurativo"
 ],
 "para el insomnio": [
  "bf-sueno"
 ],
 "para el intestino": [
  "bf-microbiota",
  "bf-transito"
 ],
 "para el maraton": [
  "bf-deporte"
 ],
 "para el mareo": [
  "bf-nauseas"
 ],
 "para el mareo del coche": [
  "bf-nauseas"
 ],
 "para el pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "para el pelo debilitado": [
  "bf-pelo-unas",
  "zinc"
 ],
 "para el posparto": [
  "bf-embarazo"
 ],
 "para el reflujo": [
  "bf-acidez"
 ],
 "para el rendimiento": [
  "bf-deporte"
 ],
 "para el resfriado de los ninos": [
  "bf-infantil",
  "bf-defensas"
 ],
 "para el sindrome premenstrual": [
  "bf-menstruacion"
 ],
 "para el sueno en mayores": [
  "bf-senior",
  "bf-sueno"
 ],
 "para el sueno infantil": [
  "bf-infantil",
  "bf-sueno"
 ],
 "para el tracto urinario": [
  "bf-vias-urinarias"
 ],
 "para el yodo": [
  "bf-tiroides",
  "yodo"
 ],
 "para eliminar el exceso de liquidos": [
  "bf-diuretico"
 ],
 "para eliminar liquidos": [
  "bf-diuretico"
 ],
 "para eliminar toxinas": [
  "bf-depurativo"
 ],
 "para entrenar": [
  "bf-deporte"
 ],
 "para espabilarme": [
  "bf-estimulante"
 ],
 "para estar mas despierto": [
  "bf-estimulante"
 ],
 "para estudiar": [
  "bf-concentracion"
 ],
 "para fortalecer el pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "para fortalecer las unas": [
  "bf-pelo-unas"
 ],
 "para fortalecer los huesos": [
  "bf-huesos",
  "calcio"
 ],
 "para ganar masa muscular": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "para gente mayor": [
  "bf-senior"
 ],
 "para hacer la digestion": [
  "bf-digestion"
 ],
 "para hacer pis mas": [
  "bf-diuretico"
 ],
 "para heridas pequenas": [
  "bf-antibacteriano"
 ],
 "para hidratar la piel desde dentro": [
  "bf-piel"
 ],
 "para hidratarme mejor": [
  "bf-hidratacion"
 ],
 "para infecciones": [
  "bf-antibacteriano"
 ],
 "para infecciones bucales": [
  "bf-antibacteriano"
 ],
 "para infecciones de garganta": [
  "bf-antibacteriano",
  "bf-respiratorio"
 ],
 "para ir al bano": [
  "bf-transito"
 ],
 "para la acidez": [
  "bf-acidez"
 ],
 "para la ansiedad": [
  "bf-relax"
 ],
 "para la ansiedad por comer": [
  "bf-saciedad"
 ],
 "para la artritis": [
  "bf-articulaciones"
 ],
 "para la artrosis": [
  "bf-articulaciones"
 ],
 "para la caida del pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "para la circulacion": [
  "bf-circulacion"
 ],
 "para la cistitis": [
  "bf-vias-urinarias"
 ],
 "para la densidad osea": [
  "bf-huesos",
  "calcio"
 ],
 "para la deshidratacion": [
  "bf-hidratacion"
 ],
 "para la diabetes": [
  "bf-glucosa"
 ],
 "para la diarrea": [
  "bf-transito"
 ],
 "para la diarrea y deshidratacion": [
  "bf-hidratacion"
 ],
 "para la digestion": [
  "bf-digestion"
 ],
 "para la disfuncion erectil": [
  "bf-libido"
 ],
 "para la energia": [
  "bf-energia"
 ],
 "para la epoca escolar": [
  "bf-infantil",
  "bf-defensas"
 ],
 "para la fatiga": [
  "bf-energia"
 ],
 "para la fertilidad": [
  "bf-embarazo"
 ],
 "para la flacidez": [
  "bf-antiedad"
 ],
 "para la flora intestinal": [
  "bf-microbiota"
 ],
 "para la funcion de la tiroides": [
  "bf-tiroides",
  "yodo"
 ],
 "para la garganta": [
  "bf-respiratorio"
 ],
 "para la gastritis": [
  "bf-acidez"
 ],
 "para la glucosa": [
  "bf-glucosa",
  "fibra"
 ],
 "para la hinchazon": [
  "bf-gases"
 ],
 "para la infeccion urinaria": [
  "bf-vias-urinarias"
 ],
 "para la inflamacion": [
  "bf-antiinflamatorio",
  "omega-3"
 ],
 "para la lactancia materna": [
  "bf-embarazo"
 ],
 "para la libido": [
  "bf-libido"
 ],
 "para la mala circulacion": [
  "bf-circulacion"
 ],
 "para la masa muscular": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "para la memoria": [
  "bf-concentracion",
  "omega-3"
 ],
 "para la menopausia": [
  "bf-menopausia"
 ],
 "para la mente": [
  "bf-concentracion"
 ],
 "para la mucosidad": [
  "bf-respiratorio"
 ],
 "para la osteoporosis": [
  "bf-huesos",
  "calcio"
 ],
 "para la osteoporosis en la menopausia": [
  "bf-huesos"
 ],
 "para la piel": [
  "bf-piel",
  "vitamina-c"
 ],
 "para la presion alta": [
  "bf-tension"
 ],
 "para la prostata": [
  "bf-prostata"
 ],
 "para la prostatitis": [
  "bf-prostata"
 ],
 "para la regla": [
  "bf-menstruacion"
 ],
 "para la resaca": [
  "bf-nauseas"
 ],
 "para la resistencia a la insulina": [
  "bf-glucosa"
 ],
 "para la retencion de liquidos": [
  "bf-metabolismo"
 ],
 "para la salud de los huesos": [
  "bf-huesos",
  "calcio"
 ],
 "para la salud masculina": [
  "bf-prostata"
 ],
 "para la sed": [
  "bf-hidratacion"
 ],
 "para la sequedad de ojos": [
  "bf-vista"
 ],
 "para la tension": [
  "bf-tension",
  "potasio"
 ],
 "para la tension alta": [
  "bf-tension",
  "potasio"
 ],
 "para la tension y el corazon": [
  "bf-tension",
  "bf-corazon"
 ],
 "para la tercera edad": [
  "bf-senior"
 ],
 "para la tiroides": [
  "bf-tiroides",
  "yodo"
 ],
 "para la tos": [
  "bf-respiratorio"
 ],
 "para la tos de los ninos": [
  "bf-infantil",
  "bf-respiratorio"
 ],
 "para la vida sexual": [
  "bf-libido"
 ],
 "para la vista": [
  "bf-vista",
  "vitamina-a"
 ],
 "para las agujetas": [
  "bf-musculo"
 ],
 "para las arrugas": [
  "bf-antiedad",
  "vitamina-c"
 ],
 "para las articulaciones": [
  "bf-articulaciones"
 ],
 "para las defensas de los ninos": [
  "bf-defensas",
  "bf-infantil",
  "vitamina-c"
 ],
 "para las defensas de los peques": [
  "bf-infantil",
  "bf-defensas"
 ],
 "para las flemas": [
  "bf-respiratorio"
 ],
 "para las infecciones de orina": [
  "bf-vias-urinarias"
 ],
 "para las nauseas": [
  "bf-nauseas"
 ],
 "para las palpitaciones": [
  "bf-corazon"
 ],
 "para las piernas cansadas": [
  "bf-circulacion"
 ],
 "para las piernas hinchadas": [
  "bf-diuretico"
 ],
 "para las unas": [
  "bf-pelo-unas"
 ],
 "para las varices": [
  "bf-circulacion"
 ],
 "para las vias urinarias": [
  "bf-vias-urinarias"
 ],
 "para levantar el animo": [
  "bf-animo"
 ],
 "para limpiar el higado": [
  "bf-depurativo"
 ],
 "para los calambres": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "para los cambios hormonales de la menopausia": [
  "bf-menopausia"
 ],
 "para los colicos menstruales": [
  "bf-menstruacion"
 ],
 "para los dolores menstruales": [
  "bf-menstruacion"
 ],
 "para los examenes": [
  "bf-concentracion"
 ],
 "para los gases": [
  "bf-gases"
 ],
 "para los huesos": [
  "bf-huesos",
  "calcio"
 ],
 "para los musculos": [
  "bf-musculo"
 ],
 "para los nervios": [
  "bf-relax"
 ],
 "para los ojos": [
  "bf-vista",
  "vitamina-a"
 ],
 "para los picos de azucar": [
  "bf-glucosa",
  "fibra"
 ],
 "para los radicales libres": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "para los rinones": [
  "bf-vias-urinarias"
 ],
 "para los sofocos": [
  "bf-menopausia"
 ],
 "para los tobillos hinchados": [
  "bf-diuretico"
 ],
 "para los trigliceridos": [
  "bf-colesterol"
 ],
 "para mantenerme despierto": [
  "bf-estimulante"
 ],
 "para mejorar el estado de animo": [
  "bf-animo"
 ],
 "para mejorar la circulacion de las piernas": [
  "bf-circulacion"
 ],
 "para mejorar la ereccion": [
  "bf-libido"
 ],
 "para mi abuela": [
  "bf-senior"
 ],
 "para mi abuelo": [
  "bf-senior"
 ],
 "para nino pequeno": [
  "bf-infantil"
 ],
 "para ninos": [
  "bf-infantil"
 ],
 "para no coger la gripe": [
  "bf-defensas"
 ],
 "para no dormirme conduciendo": [
  "bf-estimulante"
 ],
 "para no marearme": [
  "bf-nauseas"
 ],
 "para no picar entre horas": [
  "bf-saciedad"
 ],
 "para no ponerme mala": [
  "bf-defensas"
 ],
 "para no ponerme malo": [
  "bf-defensas"
 ],
 "para no quedarme dormido": [
  "bf-estimulante"
 ],
 "para orinar mas": [
  "bf-diuretico"
 ],
 "para orinar mejor los hombres": [
  "bf-prostata"
 ],
 "para perder peso": [
  "bf-metabolismo"
 ],
 "para personas mayores": [
  "bf-senior"
 ],
 "para prevenir la cistitis": [
  "bf-vias-urinarias"
 ],
 "para prevenir las arrugas": [
  "bf-antiedad",
  "vitamina-c"
 ],
 "para purificar el cuerpo": [
  "bf-depurativo"
 ],
 "para quedarme dormido rapido": [
  "bf-sueno"
 ],
 "para quedarse embarazada": [
  "bf-embarazo"
 ],
 "para quemar grasa": [
  "bf-metabolismo"
 ],
 "para quitar el hambre": [
  "bf-saciedad",
  "fibra"
 ],
 "para reforzar las defensas": [
  "bf-defensas",
  "vitamina-c",
  "zinc"
 ],
 "para regenerar el higado": [
  "bf-depurativo"
 ],
 "para regenerar la flora": [
  "bf-microbiota"
 ],
 "para regular el ciclo": [
  "bf-menstruacion"
 ],
 "para regular el colesterol": [
  "bf-colesterol",
  "fibra"
 ],
 "para regular el intestino": [
  "bf-transito",
  "fibra"
 ],
 "para regular el transito": [
  "bf-transito",
  "fibra"
 ],
 "para regular la regla": [
  "bf-menstruacion"
 ],
 "para regular las hormonas femeninas": [
  "bf-menstruacion"
 ],
 "para relajar el sistema nervioso": [
  "bf-relax"
 ],
 "para relajarme": [
  "bf-relax"
 ],
 "para rendir en el estudio sin sueno": [
  "bf-estimulante"
 ],
 "para reponer electrolitos": [
  "bf-hidratacion"
 ],
 "para reponer minerales": [
  "bf-hidratacion"
 ],
 "para reponer sales despues del deporte": [
  "bf-hidratacion",
  "bf-deporte"
 ],
 "para resistencia deportiva": [
  "bf-deporte"
 ],
 "para respirar mejor": [
  "bf-respiratorio"
 ],
 "para retrasar el envejecimiento": [
  "bf-antiedad",
  "antioxidantes"
 ],
 "para subir el animo": [
  "bf-animo"
 ],
 "para subir la libido": [
  "bf-libido"
 ],
 "para subir las defensas": [
  "bf-defensas",
  "vitamina-c"
 ],
 "para tener la piel hidratada": [
  "bf-piel"
 ],
 "para tomar de noche sin excitarme": [
  "bf-sin-cafeina",
  "bf-sueno"
 ],
 "para tonificar": [
  "bf-musculo"
 ],
 "pecho cargado": [
  "bf-respiratorio"
 ],
 "pelo debil": [
  "bf-pelo-unas"
 ],
 "pelo fino": [
  "bf-pelo-unas"
 ],
 "pelo quebradizo": [
  "bf-pelo-unas"
 ],
 "pelo sin brillo": [
  "bf-pelo-unas"
 ],
 "pensamientos que no me dejan dormir": [
  "bf-sueno"
 ],
 "perder firmeza": [
  "bf-antiedad"
 ],
 "perder peso": [
  "bf-saciedad",
  "bf-metabolismo"
 ],
 "perdida de densidad osea": [
  "bf-huesos",
  "calcio"
 ],
 "perdida de deseo sexual": [
  "bf-libido"
 ],
 "perdida de fuerza muscular": [
  "bf-musculo"
 ],
 "perdida de masa muscular": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "perdida de memoria": [
  "bf-concentracion"
 ],
 "perdida de vision con la edad": [
  "bf-vista",
  "vitamina-a"
 ],
 "perdidas abundantes con la regla": [
  "bf-menstruacion"
 ],
 "perimenopausia sintomas": [
  "bf-menopausia"
 ],
 "pesadez de estomago": [
  "bf-digestion"
 ],
 "pesadez de piernas": [
  "bf-diuretico"
 ],
 "pesadez de piernas en verano": [
  "bf-diuretico"
 ],
 "pesadez tras la comida": [
  "bf-digestion"
 ],
 "pesadillas frecuentes": [
  "bf-sueno"
 ],
 "picor al orinar": [
  "bf-vias-urinarias"
 ],
 "picor de garganta": [
  "bf-respiratorio"
 ],
 "picos de azucar": [
  "bf-glucosa",
  "fibra"
 ],
 "picos de glucosa": [
  "bf-glucosa",
  "fibra"
 ],
 "picoteo constante": [
  "bf-saciedad"
 ],
 "picoteo entre horas": [
  "bf-saciedad"
 ],
 "piedras en el rinon": [
  "bf-vias-urinarias"
 ],
 "piel apagada": [
  "bf-piel"
 ],
 "piel con acne": [
  "bf-piel"
 ],
 "piel con manchas": [
  "bf-piel"
 ],
 "piel con rojeces": [
  "bf-piel"
 ],
 "piel del rostro apagada": [
  "bf-piel"
 ],
 "piel deshidratada": [
  "bf-piel"
 ],
 "piel deshidratada y apagada": [
  "bf-piel"
 ],
 "piel envejecida": [
  "bf-antiedad",
  "bf-piel"
 ],
 "piel grasa": [
  "bf-piel"
 ],
 "piel irritada": [
  "bf-piel"
 ],
 "piel madura con arrugas": [
  "bf-antiedad",
  "bf-piel"
 ],
 "piel seca": [
  "bf-piel"
 ],
 "piel sensible": [
  "bf-piel"
 ],
 "piel sin brillo": [
  "bf-piel"
 ],
 "piernas cansadas": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "piernas hinchadas": [
  "bf-circulacion"
 ],
 "piernas hinchadas por liquidos": [
  "bf-diuretico"
 ],
 "piernas pesadas": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "pies frios": [
  "bf-circulacion"
 ],
 "pies hinchados": [
  "bf-diuretico"
 ],
 "poca produccion de leche": [
  "bf-embarazo"
 ],
 "poco apetito sexual": [
  "bf-libido"
 ],
 "ponerme fuerte": [
  "bf-musculo"
 ],
 "premenopausia sintomas": [
  "bf-menopausia"
 ],
 "preparacion para el parto": [
  "bf-embarazo"
 ],
 "presion arterial alta": [
  "bf-tension"
 ],
 "prevenir fracturas en la vejez": [
  "bf-huesos"
 ],
 "prevenir la aterosclerosis": [
  "bf-colesterol",
  "bf-circulacion"
 ],
 "prevenir la diabetes": [
  "bf-glucosa"
 ],
 "prevenir la osteoporosis": [
  "bf-huesos",
  "calcio"
 ],
 "prevenir problemas de corazon": [
  "bf-corazon"
 ],
 "prevenir resfriados": [
  "bf-defensas"
 ],
 "problemas de corazon": [
  "bf-corazon"
 ],
 "problemas de digestion": [
  "bf-digestion"
 ],
 "problemas de ereccion": [
  "bf-libido"
 ],
 "problemas de prostata": [
  "bf-prostata"
 ],
 "problemas de tiroides": [
  "bf-metabolismo",
  "yodo"
 ],
 "problemas digestivos": [
  "bf-digestion"
 ],
 "propiedades antibioticas naturales": [
  "bf-antibacteriano"
 ],
 "propoleo para las defensas": [
  "bf-antibacteriano",
  "bf-defensas"
 ],
 "prostata agrandada": [
  "bf-prostata"
 ],
 "prostata grande": [
  "bf-prostata"
 ],
 "prostata inflamada": [
  "bf-prostata"
 ],
 "prostatitis cronica": [
  "bf-prostata"
 ],
 "proteccion antioxidante": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "proteccion frente a virus": [
  "bf-defensas"
 ],
 "proteger el corazon": [
  "bf-corazon",
  "omega-3"
 ],
 "proteger el higado": [
  "bf-depurativo"
 ],
 "proteger las celulas": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "psa alto": [
  "bf-prostata"
 ],
 "psoriasis en la piel": [
  "bf-piel"
 ],
 "purificar el organismo": [
  "bf-depurativo"
 ],
 "que no lleve cafeina": [
  "bf-sin-cafeina"
 ],
 "quedar embarazada rapido": [
  "bf-embarazo"
 ],
 "quemar grasa abdominal": [
  "bf-metabolismo"
 ],
 "quemazon en el pecho": [
  "bf-acidez"
 ],
 "quiero adelgazar": [
  "bf-metabolismo"
 ],
 "quiero bajar de peso": [
  "bf-metabolismo"
 ],
 "quiero dejar de picotear": [
  "bf-saciedad"
 ],
 "quiero desinflar las piernas": [
  "bf-diuretico"
 ],
 "quiero desintoxicarme": [
  "bf-depurativo"
 ],
 "quiero dormir mejor": [
  "bf-sueno"
 ],
 "quiero eliminar liquidos": [
  "bf-diuretico"
 ],
 "quiero estar mas alegre": [
  "bf-animo"
 ],
 "quiero ganar musculo": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "quiero hacer detox": [
  "bf-depurativo"
 ],
 "quiero mas libido": [
  "bf-libido"
 ],
 "quiero perder peso": [
  "bf-metabolismo"
 ],
 "quiero quedarme embarazada": [
  "bf-embarazo"
 ],
 "quiero quemar grasa": [
  "bf-metabolismo"
 ],
 "quiero rendir mas": [
  "bf-deporte"
 ],
 "quiero retrasar las arrugas": [
  "bf-antiedad"
 ],
 "quiero tener mas leche": [
  "bf-embarazo"
 ],
 "quiero tonificar": [
  "bf-musculo"
 ],
 "quitar las ganas de picar": [
  "bf-saciedad"
 ],
 "radicales libres": [
  "bf-antioxidante",
  "antioxidantes"
 ],
 "recuperacion muscular": [
  "bf-deporte",
  "bf-musculo"
 ],
 "recuperacion posparto": [
  "bf-embarazo"
 ],
 "reducir el apetito": [
  "bf-saciedad"
 ],
 "reducir el colesterol": [
  "bf-colesterol",
  "fibra"
 ],
 "reducir la inflamacion": [
  "bf-antiinflamatorio",
  "omega-3"
 ],
 "reflujo gastrico": [
  "bf-acidez"
 ],
 "reflujo gastroesofagico": [
  "bf-acidez"
 ],
 "reforzar el sistema inmune": [
  "bf-defensas",
  "vitamina-c"
 ],
 "refuerzo inmunitario": [
  "bf-defensas"
 ],
 "reglas con mucho dolor": [
  "bf-menstruacion"
 ],
 "reglas dolorosas": [
  "bf-menstruacion"
 ],
 "reglas irregulares": [
  "bf-menstruacion"
 ],
 "reglas muy abundantes": [
  "bf-menstruacion"
 ],
 "regular el azucar en sangre": [
  "bf-glucosa"
 ],
 "regular el vientre": [
  "bf-transito"
 ],
 "regular la tension arterial": [
  "bf-tension"
 ],
 "regular las deposiciones": [
  "bf-transito"
 ],
 "rendimiento deportivo": [
  "bf-deporte"
 ],
 "rendimiento mental": [
  "bf-concentracion"
 ],
 "reponer la flora despues de antibioticos": [
  "bf-microbiota"
 ],
 "reponer sales minerales": [
  "bf-hidratacion"
 ],
 "resistencia a la insulina": [
  "bf-glucosa"
 ],
 "retencion de liquidos": [
  "bf-diuretico",
  "bf-metabolismo"
 ],
 "retencion de liquidos en las piernas": [
  "bf-circulacion"
 ],
 "retener agua": [
  "bf-diuretico"
 ],
 "retener liquidos": [
  "bf-diuretico"
 ],
 "retengo liquidos": [
  "bf-diuretico",
  "bf-metabolismo"
 ],
 "revision de prostata": [
  "bf-prostata"
 ],
 "revision de tiroides": [
  "bf-tiroides"
 ],
 "riesgo cardiovascular": [
  "bf-corazon"
 ],
 "rigidez articular": [
  "bf-articulaciones"
 ],
 "salud cardiovascular": [
  "bf-corazon"
 ],
 "salud de la piel": [
  "bf-piel",
  "vitamina-c"
 ],
 "salud del corazon": [
  "bf-corazon",
  "omega-3"
 ],
 "salud del corazon y las arterias": [
  "bf-corazon"
 ],
 "salud intestinal": [
  "bf-microbiota",
  "bf-transito"
 ],
 "salud ocular": [
  "bf-vista",
  "vitamina-a"
 ],
 "salud osea": [
  "bf-huesos",
  "calcio"
 ],
 "salud prostatica": [
  "bf-prostata"
 ],
 "se me acelera el corazon": [
  "bf-corazon"
 ],
 "se me cae el pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "se me cae mucho el pelo": [
  "bf-pelo-unas",
  "zinc"
 ],
 "se me dispara el azucar": [
  "bf-glucosa"
 ],
 "se me duermen las piernas": [
  "bf-musculo",
  "magnesio"
 ],
 "se me duermen los pies": [
  "bf-circulacion"
 ],
 "se me ha destrozado la flora": [
  "bf-microbiota"
 ],
 "se me ha retirado la regla": [
  "bf-menopausia"
 ],
 "se me hincha la tripa": [
  "bf-gases"
 ],
 "se me olvida todo": [
  "bf-concentracion"
 ],
 "se me olvidan las cosas": [
  "bf-concentracion"
 ],
 "se me parte mucho el pelo": [
  "bf-pelo-unas"
 ],
 "se me pega todo lo que pasa": [
  "bf-defensas"
 ],
 "se me sienta mal la comida": [
  "bf-digestion"
 ],
 "se me sube la comida": [
  "bf-acidez"
 ],
 "se puede tomar embarazada": [
  "bf-embarazo"
 ],
 "se puede tomar en la lactancia": [
  "bf-embarazo"
 ],
 "seguro durante el embarazo": [
  "bf-embarazo"
 ],
 "sensacion de piernas cansadas": [
  "bf-circulacion"
 ],
 "sensacion de saciedad": [
  "bf-saciedad",
  "fibra"
 ],
 "sensacion de sed constante": [
  "bf-hidratacion"
 ],
 "sensacion de vacio emocional": [
  "bf-animo"
 ],
 "sequedad de piel por la tiroides": [
  "bf-tiroides"
 ],
 "sequedad en los ojos": [
  "bf-vista"
 ],
 "sequedad ocular": [
  "bf-vista"
 ],
 "sequedad vaginal": [
  "bf-menopausia"
 ],
 "siempre tengo hambre": [
  "bf-saciedad"
 ],
 "signos de la edad": [
  "bf-antiedad"
 ],
 "sin cafeina": [
  "bf-sin-cafeina"
 ],
 "sin energia para nada": [
  "bf-energia"
 ],
 "sin fuerzas": [
  "bf-energia",
  "hierro"
 ],
 "sin pilas": [
  "bf-energia"
 ],
 "sin teina": [
  "bf-sin-cafeina"
 ],
 "sindrome de intestino irritable": [
  "bf-microbiota"
 ],
 "sindrome premenstrual": [
  "bf-menstruacion"
 ],
 "sintomas de la menopausia": [
  "bf-menopausia"
 ],
 "sistema cardiovascular": [
  "bf-corazon"
 ],
 "sistema digestivo": [
  "bf-digestion"
 ],
 "sistema inmune debil": [
  "bf-defensas",
  "zinc"
 ],
 "sistema inmunitario": [
  "bf-defensas"
 ],
 "sistema inmunitario debil": [
  "bf-defensas"
 ],
 "sistema nervioso alterado": [
  "bf-relax"
 ],
 "sofocos de la menopausia": [
  "bf-menopausia"
 ],
 "sofocos menopausia": [
  "bf-menopausia"
 ],
 "sofocos por la noche": [
  "bf-menopausia"
 ],
 "subida de colesterol": [
  "bf-colesterol"
 ],
 "subidon de azucar": [
  "bf-glucosa"
 ],
 "subir las defensas": [
  "bf-defensas",
  "vitamina-c"
 ],
 "sudo mucho y me deshidrato": [
  "bf-hidratacion"
 ],
 "sudoracion nocturna": [
  "bf-menopausia"
 ],
 "sudores nocturnos": [
  "bf-menopausia"
 ],
 "sueno interrumpido": [
  "bf-sueno"
 ],
 "sueno ligero": [
  "bf-sueno"
 ],
 "sueno reparador": [
  "bf-sueno"
 ],
 "suero casero": [
  "bf-hidratacion"
 ],
 "suero de rehidratacion": [
  "bf-hidratacion"
 ],
 "suplementos para embarazadas": [
  "bf-embarazo"
 ],
 "sustituto del cafe": [
  "bf-estimulante"
 ],
 "temporada de gripe": [
  "bf-defensas"
 ],
 "tengo acidez": [
  "bf-acidez"
 ],
 "tengo agujetas": [
  "bf-musculo"
 ],
 "tengo ansiedad": [
  "bf-relax"
 ],
 "tengo ansiedad por el dulce": [
  "bf-glucosa"
 ],
 "tengo bochornos": [
  "bf-menopausia"
 ],
 "tengo calambres": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "tengo cistitis": [
  "bf-vias-urinarias"
 ],
 "tengo el azucar alto": [
  "bf-glucosa"
 ],
 "tengo el colesterol alto": [
  "bf-colesterol"
 ],
 "tengo el colesteron alto": [
  "bf-colesterol"
 ],
 "tengo el higado tocado": [
  "bf-depurativo"
 ],
 "tengo estrenimiento": [
  "bf-transito"
 ],
 "tengo ganas de devolver": [
  "bf-nauseas"
 ],
 "tengo hashimoto": [
  "bf-tiroides"
 ],
 "tengo inflamacion": [
  "bf-antiinflamatorio"
 ],
 "tengo insomnio": [
  "bf-sueno"
 ],
 "tengo la flora intestinal mal": [
  "bf-microbiota"
 ],
 "tengo la glucosa alta": [
  "bf-glucosa"
 ],
 "tengo la mente en blanco": [
  "bf-concentracion"
 ],
 "tengo la nariz tapada": [
  "bf-respiratorio"
 ],
 "tengo la tension alta": [
  "bf-tension"
 ],
 "tengo mala digestion": [
  "bf-digestion"
 ],
 "tengo mucha sed": [
  "bf-hidratacion"
 ],
 "tengo muchos gases": [
  "bf-gases"
 ],
 "tengo nauseas": [
  "bf-nauseas"
 ],
 "tengo sofocos": [
  "bf-menopausia"
 ],
 "tengo tos": [
  "bf-respiratorio"
 ],
 "tension alta": [
  "bf-tension",
  "potasio"
 ],
 "tension arterial descontrolada": [
  "bf-tension"
 ],
 "tension emocional": [
  "bf-relax"
 ],
 "tension nerviosa": [
  "bf-relax"
 ],
 "tension nerviosa alta": [
  "bf-tension"
 ],
 "tension por las nubes": [
  "bf-tension"
 ],
 "tension premenstrual": [
  "bf-menstruacion"
 ],
 "tiene propiedades antisepticas": [
  "bf-antibacteriano"
 ],
 "tiroides agrandada": [
  "bf-tiroides"
 ],
 "tiroides hipoactiva": [
  "bf-tiroides",
  "yodo"
 ],
 "tiroides lenta": [
  "bf-metabolismo",
  "yodo"
 ],
 "tiroides perezosa": [
  "bf-tiroides",
  "yodo"
 ],
 "tiroiditis de hashimoto": [
  "bf-tiroides"
 ],
 "tobillos hinchados": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "todo el dia bostezando": [
  "bf-energia"
 ],
 "todo me da igual": [
  "bf-animo"
 ],
 "tos con flemas": [
  "bf-respiratorio"
 ],
 "tos de perro": [
  "bf-respiratorio"
 ],
 "tos nocturna": [
  "bf-respiratorio",
  "bf-sueno"
 ],
 "tos persistente": [
  "bf-respiratorio"
 ],
 "tos seca": [
  "bf-respiratorio"
 ],
 "transito intestinal": [
  "bf-transito"
 ],
 "transito intestinal lento": [
  "bf-transito",
  "fibra"
 ],
 "trastornos del sueno": [
  "bf-sueno"
 ],
 "trigliceridos altos": [
  "bf-colesterol"
 ],
 "tripa a punto de explotar": [
  "bf-gases"
 ],
 "tripa cerrada": [
  "bf-transito"
 ],
 "tripa como un globo": [
  "bf-gases"
 ],
 "tripa hinchada": [
  "bf-gases",
  "bf-digestion"
 ],
 "tripa inflada despues de comer": [
  "bf-gases"
 ],
 "triptofano para dormir": [
  "bf-sueno",
  "triptofano",
  "melatonina"
 ],
 "tristeza otonal": [
  "bf-animo"
 ],
 "tristeza sin motivo": [
  "bf-animo"
 ],
 "tsh alta": [
  "bf-tiroides"
 ],
 "tsh elevada": [
  "bf-tiroides"
 ],
 "turno de noche": [
  "bf-sueno"
 ],
 "unas debiles": [
  "bf-pelo-unas"
 ],
 "unas debiles y quebradizas": [
  "bf-pelo-unas"
 ],
 "unas fragiles": [
  "bf-pelo-unas"
 ],
 "unas que se rompen": [
  "bf-pelo-unas"
 ],
 "unas quebradizas": [
  "bf-pelo-unas"
 ],
 "varices en las piernas": [
  "bf-circulacion"
 ],
 "vias respiratorias": [
  "bf-respiratorio"
 ],
 "vias urinarias": [
  "bf-vias-urinarias"
 ],
 "vientre cerrado": [
  "bf-transito"
 ],
 "vientre hinchado y estrenido": [
  "bf-transito",
  "bf-gases"
 ],
 "vientre perezoso": [
  "bf-transito"
 ],
 "vientre vago": [
  "bf-transito"
 ],
 "vision borrosa": [
  "bf-vista"
 ],
 "vista cansada": [
  "bf-vista",
  "vitamina-a"
 ],
 "vista cansada de la pantalla": [
  "bf-vista"
 ],
 "vista cansada de leer": [
  "bf-vista"
 ],
 "vista cansada por el movil": [
  "bf-vista"
 ],
 "vitaminas para el embarazo": [
  "bf-embarazo"
 ],
 "vitaminas para mayores": [
  "bf-senior"
 ],
 "vitaminas para ninos": [
  "bf-infantil"
 ],
 "vomitos frecuentes": [
  "bf-nauseas"
 ],
 "voy al gimnasio": [
  "bf-deporte"
 ],
 "voy fatal al bano": [
  "bf-transito"
 ],
 "voy mal al bano": [
  "bf-transito"
 ],
 "voy mucho al bano a orinar": [
  "bf-vias-urinarias"
 ],
 "vuelta al cole": [
  "bf-infantil",
  "bf-defensas"
 ],
 "vuelta al cole y los virus": [
  "bf-defensas",
  "bf-infantil"
 ],
 "vueltas en la cama sin dormir": [
  "bf-sueno"
 ]
},
  palabras: {
 "abatida": [
  "bf-energia"
 ],
 "abatido": [
  "bf-energia"
 ],
 "abuela": [
  "bf-senior"
 ],
 "abuelo": [
  "bf-senior"
 ],
 "abuelos": [
  "bf-senior"
 ],
 "acatarrada": [
  "bf-defensas"
 ],
 "acatarrado": [
  "bf-defensas"
 ],
 "acatarrarse": [
  "bf-defensas"
 ],
 "acidez": [
  "bf-acidez"
 ],
 "acne": [
  "bf-piel"
 ],
 "acneica": [
  "bf-piel"
 ],
 "activador": [
  "bf-estimulante"
 ],
 "adelgazamiento": [
  "bf-metabolismo"
 ],
 "adelgazar": [
  "bf-saciedad",
  "bf-metabolismo"
 ],
 "adenoma": [
  "bf-prostata"
 ],
 "adormidera": [
  "bf-sueno"
 ],
 "adormilada": [
  "bf-energia"
 ],
 "adormilado": [
  "bf-energia"
 ],
 "adormilarse": [
  "bf-sueno"
 ],
 "aerofagia": [
  "bf-gases"
 ],
 "afonia": [
  "bf-respiratorio"
 ],
 "afonica": [
  "bf-respiratorio"
 ],
 "afonico": [
  "bf-respiratorio"
 ],
 "afrodisiaca": [
  "bf-libido"
 ],
 "afrodisiacas": [
  "bf-libido"
 ],
 "afrodisiaco": [
  "bf-libido"
 ],
 "afrodisiacos": [
  "bf-libido"
 ],
 "agobiada": [
  "bf-relax"
 ],
 "agobiado": [
  "bf-relax"
 ],
 "agobio": [
  "bf-relax"
 ],
 "agotada": [
  "bf-energia"
 ],
 "agotado": [
  "bf-energia"
 ],
 "agotamiento": [
  "bf-energia"
 ],
 "agujetas": [
  "bf-musculo"
 ],
 "alegria": [
  "bf-animo"
 ],
 "alerta": [
  "bf-estimulante"
 ],
 "alopecia": [
  "bf-pelo-unas"
 ],
 "amamantamiento": [
  "bf-embarazo"
 ],
 "amamantar": [
  "bf-embarazo"
 ],
 "amapola": [
  "bf-sueno"
 ],
 "amenorrea": [
  "bf-menstruacion"
 ],
 "amigdalitis": [
  "bf-respiratorio"
 ],
 "amnesia": [
  "bf-concentracion"
 ],
 "ancianos": [
  "bf-senior"
 ],
 "anciedad": [
  "bf-relax"
 ],
 "anemia": [
  "hierro",
  "bf-energia"
 ],
 "angina": [
  "bf-corazon"
 ],
 "anginas": [
  "bf-corazon"
 ],
 "angustia": [
  "bf-relax"
 ],
 "animica": [
  "bf-animo"
 ],
 "animico": [
  "bf-animo"
 ],
 "animo": [
  "bf-animo"
 ],
 "anorgasmia": [
  "bf-libido"
 ],
 "ansiedad": [
  "bf-relax"
 ],
 "ansiolitico": [
  "bf-relax"
 ],
 "ansiosa": [
  "bf-relax"
 ],
 "ansioso": [
  "bf-relax"
 ],
 "antiacido": [
  "bf-acidez"
 ],
 "antiaging": [
  "bf-antiedad"
 ],
 "antiarrugas": [
  "bf-antiedad"
 ],
 "antibacteriano": [
  "bf-antibacteriano"
 ],
 "antiedad": [
  "bf-antiedad"
 ],
 "antiemetico": [
  "bf-nauseas"
 ],
 "antienvejecimiento": [
  "bf-antiedad"
 ],
 "antifungico": [
  "bf-antibacteriano"
 ],
 "antihipertensivo": [
  "bf-tension"
 ],
 "antiinflamatoria": [
  "bf-antiinflamatorio"
 ],
 "antiinflamatorio": [
  "bf-antiinflamatorio"
 ],
 "antiinflamatorios": [
  "bf-antiinflamatorio"
 ],
 "antimicrobiano": [
  "bf-antibacteriano"
 ],
 "antioxidacion": [
  "bf-antioxidante"
 ],
 "antioxidante": [
  "bf-antioxidante"
 ],
 "antioxidantes": [
  "bf-antioxidante"
 ],
 "antiseptico": [
  "bf-antibacteriano"
 ],
 "antiviral": [
  "bf-antibacteriano",
  "bf-defensas"
 ],
 "apatia": [
  "bf-energia"
 ],
 "apetito": [
  "bf-saciedad"
 ],
 "arandano": [
  "bf-vias-urinarias"
 ],
 "arandanos": [
  "bf-vias-urinarias"
 ],
 "ardor": [
  "bf-acidez"
 ],
 "arritmia": [
  "bf-corazon"
 ],
 "arruga": [
  "bf-antiedad"
 ],
 "arrugada": [
  "bf-antiedad"
 ],
 "arrugado": [
  "bf-antiedad"
 ],
 "arrugas": [
  "bf-antiedad",
  "bf-piel"
 ],
 "arteria": [
  "bf-corazon",
  "bf-circulacion"
 ],
 "arterias": [
  "bf-corazon",
  "bf-circulacion"
 ],
 "arteriosclerosis": [
  "bf-colesterol",
  "bf-circulacion"
 ],
 "articulaciones": [
  "bf-articulaciones"
 ],
 "articular": [
  "bf-articulaciones"
 ],
 "articulares": [
  "bf-articulaciones"
 ],
 "artralgia": [
  "bf-articulaciones"
 ],
 "artralgias": [
  "bf-articulaciones"
 ],
 "artritis": [
  "bf-articulaciones"
 ],
 "artropatia": [
  "bf-articulaciones"
 ],
 "artrosis": [
  "bf-articulaciones"
 ],
 "asidez": [
  "bf-acidez"
 ],
 "asma": [
  "bf-respiratorio"
 ],
 "astenia": [
  "bf-energia"
 ],
 "astigmatismo": [
  "bf-vista"
 ],
 "aterosclerosis": [
  "bf-colesterol",
  "bf-circulacion"
 ],
 "atleta": [
  "bf-deporte"
 ],
 "atletas": [
  "bf-deporte"
 ],
 "atracon": [
  "bf-saciedad"
 ],
 "atracones": [
  "bf-saciedad"
 ],
 "azafran": [
  "bf-animo"
 ],
 "azahar": [
  "bf-relax"
 ],
 "azucar": [
  "bf-glucosa"
 ],
 "bacterias": [
  "bf-antibacteriano"
 ],
 "bactericida": [
  "bf-antibacteriano"
 ],
 "bajon": [
  "bf-animo",
  "bf-energia"
 ],
 "bebe": [
  "bf-infantil"
 ],
 "bebes": [
  "bf-infantil"
 ],
 "biliar": [
  "bf-depurativo"
 ],
 "biliares": [
  "bf-depurativo"
 ],
 "biliosa": [
  "bf-depurativo"
 ],
 "biliosidad": [
  "bf-depurativo"
 ],
 "bilis": [
  "bf-depurativo"
 ],
 "bio": [
  "ecologico"
 ],
 "biotina": [
  "bf-pelo-unas"
 ],
 "bochorno": [
  "bf-menopausia"
 ],
 "bochornos": [
  "bf-menopausia"
 ],
 "bocio": [
  "bf-metabolismo",
  "yodo"
 ],
 "bradicardia": [
  "bf-corazon"
 ],
 "bronquios": [
  "bf-respiratorio"
 ],
 "bronquitis": [
  "bf-respiratorio"
 ],
 "bursitis": [
  "bf-articulaciones"
 ],
 "cabello": [
  "bf-pelo-unas"
 ],
 "cafeina": [
  "bf-estimulante"
 ],
 "cafeinado": [
  "bf-estimulante"
 ],
 "calambre": [
  "bf-musculo",
  "magnesio",
  "potasio"
 ],
 "calambres": [
  "magnesio",
  "potasio",
  "bf-musculo"
 ],
 "calcica": [
  "bf-huesos"
 ],
 "calcico": [
  "bf-huesos"
 ],
 "calcificacion": [
  "bf-huesos"
 ],
 "calculos": [
  "bf-vias-urinarias"
 ],
 "calma": [
  "bf-relax"
 ],
 "calvicie": [
  "bf-pelo-unas"
 ],
 "canas": [
  "bf-pelo-unas"
 ],
 "candidiasis": [
  "bf-microbiota"
 ],
 "cansada": [
  "bf-energia"
 ],
 "cansado": [
  "bf-energia"
 ],
 "cansancio": [
  "bf-energia",
  "hierro"
 ],
 "capilar": [
  "bf-pelo-unas"
 ],
 "capilares": [
  "bf-circulacion"
 ],
 "cardiaca": [
  "bf-corazon"
 ],
 "cardiaco": [
  "bf-corazon"
 ],
 "cardio": [
  "bf-corazon"
 ],
 "cardiologo": [
  "bf-corazon"
 ],
 "cardiopatia": [
  "bf-corazon"
 ],
 "cardiopatias": [
  "bf-corazon"
 ],
 "cardioprotector": [
  "bf-corazon"
 ],
 "cardiotonico": [
  "bf-corazon"
 ],
 "cardiovascular": [
  "bf-corazon"
 ],
 "carminativo": [
  "bf-gases"
 ],
 "carotenoides": [
  "bf-antioxidante"
 ],
 "carraspera": [
  "bf-respiratorio"
 ],
 "cartilago": [
  "bf-articulaciones"
 ],
 "caspa": [
  "bf-pelo-unas"
 ],
 "cataratas": [
  "bf-vista"
 ],
 "catarral": [
  "bf-defensas"
 ],
 "catarro": [
  "bf-defensas"
 ],
 "celiaco": [
  "sin-gluten"
 ],
 "celulitis": [
  "bf-metabolismo"
 ],
 "cerebro": [
  "bf-concentracion"
 ],
 "chavales": [
  "bf-infantil"
 ],
 "chiquillos": [
  "bf-infantil"
 ],
 "ciatica": [
  "bf-articulaciones"
 ],
 "ciclismo": [
  "bf-deporte"
 ],
 "cimicifuga": [
  "bf-menopausia"
 ],
 "circulacion": [
  "bf-circulacion"
 ],
 "circulatoria": [
  "bf-circulacion"
 ],
 "circulatorio": [
  "bf-circulacion"
 ],
 "cistalgia": [
  "bf-vias-urinarias"
 ],
 "cistitis": [
  "bf-vias-urinarias"
 ],
 "climaterica": [
  "bf-menopausia"
 ],
 "climaterio": [
  "bf-menopausia"
 ],
 "cognitivo": [
  "bf-concentracion"
 ],
 "cohosh": [
  "bf-menopausia"
 ],
 "colageno": [
  "bf-piel",
  "bf-antiedad"
 ],
 "colagogo": [
  "bf-depurativo"
 ],
 "coleretica": [
  "bf-depurativo"
 ],
 "coleretico": [
  "bf-depurativo"
 ],
 "colesterol": [
  "bf-colesterol"
 ],
 "colesterolemia": [
  "bf-colesterol"
 ],
 "colesteron": [
  "bf-colesterol"
 ],
 "colicos": [
  "bf-menstruacion"
 ],
 "comilona": [
  "bf-digestion"
 ],
 "concentracion": [
  "bf-concentracion"
 ],
 "concentrarse": [
  "bf-concentracion"
 ],
 "concepcion": [
  "bf-embarazo"
 ],
 "condroitina": [
  "bf-articulaciones"
 ],
 "congestion": [
  "bf-respiratorio"
 ],
 "conjuntivitis": [
  "bf-vista"
 ],
 "constipada": [
  "bf-defensas"
 ],
 "constipado": [
  "bf-defensas"
 ],
 "contractura": [
  "bf-musculo"
 ],
 "contracturas": [
  "bf-musculo"
 ],
 "convalecencia": [
  "bf-defensas"
 ],
 "corazon": [
  "bf-corazon"
 ],
 "corazoncito": [
  "bf-corazon"
 ],
 "coronaria": [
  "bf-corazon"
 ],
 "coronarias": [
  "bf-corazon"
 ],
 "corredor": [
  "bf-deporte"
 ],
 "corredores": [
  "bf-deporte"
 ],
 "criaturas": [
  "bf-infantil"
 ],
 "crossfit": [
  "bf-deporte"
 ],
 "cutanea": [
  "bf-piel"
 ],
 "cutaneo": [
  "bf-piel"
 ],
 "cutis": [
  "bf-piel"
 ],
 "debilidad": [
  "bf-energia"
 ],
 "decaida": [
  "bf-energia"
 ],
 "decaido": [
  "bf-energia"
 ],
 "decaimiento": [
  "bf-energia"
 ],
 "defecacion": [
  "bf-transito"
 ],
 "defecar": [
  "bf-transito"
 ],
 "defensas": [
  "bf-defensas",
  "vitamina-c"
 ],
 "deporte": [
  "bf-deporte"
 ],
 "deportista": [
  "bf-deporte"
 ],
 "deportistas": [
  "bf-deporte"
 ],
 "deposiciones": [
  "bf-transito"
 ],
 "depuracion": [
  "bf-depurativo"
 ],
 "depurar": [
  "bf-depurativo",
  "bf-metabolismo"
 ],
 "depurarse": [
  "bf-depurativo"
 ],
 "depurativo": [
  "bf-depurativo",
  "bf-metabolismo"
 ],
 "dermatitis": [
  "bf-piel"
 ],
 "dermatologica": [
  "bf-piel"
 ],
 "dermatologico": [
  "bf-piel"
 ],
 "dermica": [
  "bf-piel"
 ],
 "dermico": [
  "bf-piel"
 ],
 "desaguar": [
  "bf-diuretico"
 ],
 "desanimada": [
  "bf-animo"
 ],
 "desanimado": [
  "bf-animo"
 ],
 "desanimo": [
  "bf-animo"
 ],
 "descafeinada": [
  "bf-sin-cafeina"
 ],
 "descafeinado": [
  "bf-sin-cafeina"
 ],
 "descafeinados": [
  "bf-sin-cafeina"
 ],
 "descalcificacion": [
  "bf-huesos"
 ],
 "descansar": [
  "bf-sueno"
 ],
 "descanso": [
  "bf-sueno"
 ],
 "deseo": [
  "bf-libido"
 ],
 "desfallecida": [
  "bf-energia"
 ],
 "desfallecido": [
  "bf-energia"
 ],
 "desgana": [
  "bf-animo"
 ],
 "desganada": [
  "bf-energia"
 ],
 "desganado": [
  "bf-energia"
 ],
 "deshidratacion": [
  "bf-hidratacion"
 ],
 "deshidratada": [
  "bf-hidratacion"
 ],
 "deshidratado": [
  "bf-hidratacion"
 ],
 "deshinchar": [
  "bf-diuretico"
 ],
 "desinfectante": [
  "bf-antibacteriano"
 ],
 "desinflama": [
  "bf-antiinflamatorio"
 ],
 "desintoxicacion": [
  "bf-metabolismo"
 ],
 "desintoxicada": [
  "bf-depurativo"
 ],
 "desintoxicado": [
  "bf-depurativo"
 ],
 "desintoxicante": [
  "bf-metabolismo"
 ],
 "desintoxicar": [
  "bf-metabolismo"
 ],
 "desmemoriada": [
  "bf-concentracion"
 ],
 "desmemoriado": [
  "bf-concentracion"
 ],
 "desmineralizacion": [
  "bf-huesos"
 ],
 "despistada": [
  "bf-concentracion"
 ],
 "despistado": [
  "bf-concentracion"
 ],
 "despiste": [
  "bf-concentracion"
 ],
 "despistes": [
  "bf-concentracion"
 ],
 "desvelada": [
  "bf-sueno"
 ],
 "desvelado": [
  "bf-sueno"
 ],
 "desvelarse": [
  "bf-sueno"
 ],
 "desvelo": [
  "bf-sueno"
 ],
 "detox": [
  "bf-depurativo",
  "bf-metabolismo"
 ],
 "detoxificacion": [
  "bf-depurativo"
 ],
 "detoxificante": [
  "bf-depurativo"
 ],
 "diabetes": [
  "bf-glucosa"
 ],
 "diabetica": [
  "bf-glucosa"
 ],
 "diabetico": [
  "bf-glucosa"
 ],
 "diabetis": [
  "bf-glucosa"
 ],
 "diarrea": [
  "bf-transito"
 ],
 "diarreas": [
  "bf-transito"
 ],
 "diastolica": [
  "bf-tension"
 ],
 "dieta": [
  "bf-saciedad"
 ],
 "digerir": [
  "bf-digestion"
 ],
 "digestible": [
  "bf-digestion"
 ],
 "digestion": [
  "bf-digestion"
 ],
 "digestiones": [
  "bf-digestion"
 ],
 "digestiva": [
  "bf-digestion"
 ],
 "digestivo": [
  "bf-digestion"
 ],
 "dijestion": [
  "bf-digestion"
 ],
 "disbiosis": [
  "bf-microbiota"
 ],
 "dislipemia": [
  "bf-colesterol"
 ],
 "dismenorrea": [
  "bf-menstruacion"
 ],
 "dispepsia": [
  "bf-digestion"
 ],
 "distraida": [
  "bf-concentracion"
 ],
 "distraido": [
  "bf-concentracion"
 ],
 "disuria": [
  "bf-vias-urinarias"
 ],
 "diuresis": [
  "bf-diuretico"
 ],
 "diuretica": [
  "bf-diuretico"
 ],
 "diuretico": [
  "bf-diuretico"
 ],
 "diureticos": [
  "bf-diuretico"
 ],
 "dormir": [
  "bf-sueno"
 ],
 "dormirse": [
  "bf-sueno"
 ],
 "dormitar": [
  "bf-sueno"
 ],
 "drenaje": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "drenante": [
  "bf-diuretico",
  "bf-metabolismo"
 ],
 "drenar": [
  "bf-metabolismo"
 ],
 "duermevela": [
  "bf-sueno"
 ],
 "eccema": [
  "bf-piel"
 ],
 "ecologico": [
  "ecologico"
 ],
 "eczema": [
  "bf-piel"
 ],
 "edema": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "edemas": [
  "bf-circulacion",
  "bf-diuretico"
 ],
 "edematosa": [
  "bf-diuretico"
 ],
 "edematoso": [
  "bf-diuretico"
 ],
 "elastina": [
  "bf-antiedad",
  "bf-piel"
 ],
 "electrolito": [
  "bf-hidratacion"
 ],
 "electrolitos": [
  "bf-hidratacion"
 ],
 "embarazada": [
  "bf-embarazo",
  "vitamina-b9"
 ],
 "embarazadas": [
  "bf-embarazo"
 ],
 "embarazo": [
  "bf-embarazo",
  "vitamina-b9"
 ],
 "empachada": [
  "bf-digestion"
 ],
 "empachado": [
  "bf-digestion"
 ],
 "empacho": [
  "bf-digestion"
 ],
 "empachos": [
  "bf-digestion"
 ],
 "encanecimiento": [
  "bf-pelo-unas"
 ],
 "endometriosis": [
  "bf-menstruacion"
 ],
 "energetico": [
  "bf-energia"
 ],
 "energia": [
  "bf-energia"
 ],
 "energizante": [
  "bf-energia"
 ],
 "entrenamiento": [
  "bf-deporte"
 ],
 "entrenar": [
  "bf-deporte"
 ],
 "entumecimiento": [
  "bf-circulacion"
 ],
 "envejecimiento": [
  "bf-antiedad",
  "bf-senior"
 ],
 "equinacea": [
  "bf-defensas"
 ],
 "ereccion": [
  "bf-libido"
 ],
 "erectil": [
  "bf-libido"
 ],
 "eructar": [
  "bf-gases"
 ],
 "eructo": [
  "bf-gases"
 ],
 "eructos": [
  "bf-gases"
 ],
 "escolares": [
  "bf-infantil"
 ],
 "escozor": [
  "bf-vias-urinarias"
 ],
 "espabilar": [
  "bf-estimulante"
 ],
 "espasmos": [
  "bf-menstruacion"
 ],
 "espinillas": [
  "bf-piel"
 ],
 "espino": [
  "bf-relax"
 ],
 "estatina": [
  "bf-colesterol"
 ],
 "estatinas": [
  "bf-colesterol"
 ],
 "esteatosis": [
  "bf-depurativo"
 ],
 "esterilizante": [
  "bf-antibacteriano"
 ],
 "estimulante": [
  "bf-estimulante"
 ],
 "estomacal": [
  "bf-digestion"
 ],
 "estomago": [
  "bf-digestion",
  "bf-acidez"
 ],
 "estornudos": [
  "bf-respiratorio"
 ],
 "estrenida": [
  "bf-transito"
 ],
 "estrenido": [
  "bf-transito",
  "fibra"
 ],
 "estrenimiento": [
  "bf-transito",
  "fibra"
 ],
 "estres": [
  "bf-relax"
 ],
 "estresada": [
  "bf-relax"
 ],
 "estresadas": [
  "bf-relax"
 ],
 "estresado": [
  "bf-relax"
 ],
 "estresados": [
  "bf-relax"
 ],
 "estresante": [
  "bf-relax"
 ],
 "estress": [
  "bf-relax"
 ],
 "estrogenica": [
  "bf-menopausia"
 ],
 "estrogenos": [
  "bf-menopausia"
 ],
 "estudiar": [
  "bf-concentracion"
 ],
 "eucalipto": [
  "bf-respiratorio"
 ],
 "evacuar": [
  "bf-transito"
 ],
 "excitante": [
  "bf-sin-cafeina"
 ],
 "excitantes": [
  "bf-sin-cafeina"
 ],
 "exfoliacion": [
  "bf-piel"
 ],
 "expectoracion": [
  "bf-respiratorio"
 ],
 "expectorante": [
  "bf-respiratorio"
 ],
 "extenuada": [
  "bf-energia"
 ],
 "extenuado": [
  "bf-energia"
 ],
 "extremidades": [
  "bf-circulacion"
 ],
 "extrenido": [
  "bf-transito"
 ],
 "extrenimiento": [
  "bf-transito",
  "fibra"
 ],
 "eyaculacion": [
  "bf-libido"
 ],
 "faringitis": [
  "bf-respiratorio"
 ],
 "fatiga": [
  "bf-energia",
  "hierro"
 ],
 "fertilidad": [
  "bf-embarazo"
 ],
 "firmeza": [
  "bf-antiedad"
 ],
 "fitoestrogenos": [
  "bf-menopausia"
 ],
 "flacidez": [
  "bf-antiedad"
 ],
 "flatulencia": [
  "bf-gases"
 ],
 "flatulencias": [
  "bf-gases"
 ],
 "flavonoides": [
  "bf-antioxidante"
 ],
 "flebitis": [
  "bf-circulacion"
 ],
 "flemas": [
  "bf-respiratorio"
 ],
 "flojedad": [
  "bf-energia"
 ],
 "flojera": [
  "bf-energia"
 ],
 "flora": [
  "bf-microbiota"
 ],
 "folicular": [
  "bf-pelo-unas"
 ],
 "foliculos": [
  "bf-pelo-unas"
 ],
 "fractura": [
  "bf-huesos"
 ],
 "fracturas": [
  "bf-huesos"
 ],
 "frigidez": [
  "bf-libido"
 ],
 "garganta": [
  "bf-respiratorio"
 ],
 "gargarismos": [
  "bf-respiratorio"
 ],
 "gases": [
  "bf-gases"
 ],
 "gastralgia": [
  "bf-digestion"
 ],
 "gastrico": [
  "bf-acidez",
  "bf-digestion"
 ],
 "gastritis": [
  "bf-acidez"
 ],
 "gastroenteritis": [
  "bf-nauseas",
  "bf-transito"
 ],
 "geriatria": [
  "bf-senior"
 ],
 "geriatrico": [
  "bf-senior"
 ],
 "germenes": [
  "bf-antibacteriano"
 ],
 "gestacion": [
  "bf-embarazo"
 ],
 "gestacional": [
  "bf-embarazo"
 ],
 "gestante": [
  "bf-embarazo"
 ],
 "gestantes": [
  "bf-embarazo"
 ],
 "gimnasio": [
  "bf-deporte",
  "bf-musculo"
 ],
 "ginseng": [
  "bf-estimulante"
 ],
 "glaucoma": [
  "bf-vista"
 ],
 "glucemia": [
  "bf-glucosa"
 ],
 "glucemico": [
  "bf-glucosa"
 ],
 "glucosa": [
  "bf-glucosa"
 ],
 "glucosamina": [
  "bf-articulaciones"
 ],
 "gordolobo": [
  "bf-respiratorio"
 ],
 "gripal": [
  "bf-defensas"
 ],
 "gripe": [
  "bf-respiratorio",
  "bf-defensas"
 ],
 "guarana": [
  "bf-estimulante"
 ],
 "guarderia": [
  "bf-infantil"
 ],
 "gula": [
  "bf-saciedad"
 ],
 "gym": [
  "bf-deporte",
  "bf-musculo"
 ],
 "hambre": [
  "bf-saciedad"
 ],
 "hambrienta": [
  "bf-saciedad"
 ],
 "hambriento": [
  "bf-saciedad"
 ],
 "hashimoto": [
  "bf-tiroides"
 ],
 "hbp": [
  "bf-prostata"
 ],
 "hdl": [
  "bf-colesterol"
 ],
 "hepatica": [
  "bf-depurativo"
 ],
 "hepatico": [
  "bf-depurativo"
 ],
 "hepatobiliar": [
  "bf-depurativo"
 ],
 "hepatopatia": [
  "bf-depurativo"
 ],
 "hepatoprotector": [
  "bf-depurativo"
 ],
 "hepatoprotectora": [
  "bf-depurativo"
 ],
 "hepatotoxica": [
  "bf-depurativo"
 ],
 "hepatotoxico": [
  "bf-depurativo"
 ],
 "hidratacion": [
  "bf-piel",
  "bf-hidratacion"
 ],
 "hidratada": [
  "bf-hidratacion"
 ],
 "hidratado": [
  "bf-hidratacion"
 ],
 "hidratante": [
  "bf-hidratacion"
 ],
 "hidropesia": [
  "bf-diuretico"
 ],
 "higado": [
  "bf-depurativo"
 ],
 "higados": [
  "bf-depurativo"
 ],
 "hinchada": [
  "bf-gases"
 ],
 "hinchado": [
  "bf-gases"
 ],
 "hinchazon": [
  "bf-gases"
 ],
 "hinchazones": [
  "bf-gases"
 ],
 "hipercolesterolemia": [
  "bf-colesterol"
 ],
 "hipercolesterolemico": [
  "bf-colesterol"
 ],
 "hiperglucemia": [
  "bf-glucosa"
 ],
 "hiperico": [
  "bf-animo"
 ],
 "hipermenorrea": [
  "bf-menstruacion"
 ],
 "hipermetropia": [
  "bf-vista"
 ],
 "hiperplasia": [
  "bf-prostata"
 ],
 "hipertensa": [
  "bf-tension"
 ],
 "hipertension": [
  "bf-tension",
  "potasio"
 ],
 "hipertensiva": [
  "bf-tension"
 ],
 "hipertensivo": [
  "bf-tension"
 ],
 "hipertenso": [
  "bf-tension"
 ],
 "hipertiroidea": [
  "bf-tiroides"
 ],
 "hipertiroidismo": [
  "bf-tiroides"
 ],
 "hipnotico": [
  "bf-sueno"
 ],
 "hipoglucemia": [
  "bf-glucosa"
 ],
 "hipoglucemiante": [
  "bf-glucosa"
 ],
 "hipomenorrea": [
  "bf-menstruacion"
 ],
 "hiponatremia": [
  "bf-hidratacion"
 ],
 "hipotensa": [
  "bf-tension"
 ],
 "hipotension": [
  "bf-tension"
 ],
 "hipotenso": [
  "bf-tension"
 ],
 "hipotiroidea": [
  "bf-tiroides"
 ],
 "hipotiroidismo": [
  "bf-metabolismo",
  "yodo"
 ],
 "hormigueo": [
  "bf-circulacion"
 ],
 "hueso": [
  "bf-huesos"
 ],
 "huesos": [
  "bf-huesos",
  "calcio"
 ],
 "humor": [
  "bf-animo"
 ],
 "impotencia": [
  "bf-libido"
 ],
 "impotente": [
  "bf-libido"
 ],
 "impurezas": [
  "bf-piel"
 ],
 "imsomnio": [
  "bf-sueno"
 ],
 "imsonio": [
  "bf-sueno"
 ],
 "indigestion": [
  "bf-digestion"
 ],
 "infantil": [
  "bf-infantil"
 ],
 "infarto": [
  "bf-corazon"
 ],
 "infeccion": [
  "bf-antibacteriano"
 ],
 "infecciones": [
  "bf-antibacteriano"
 ],
 "inflamacion": [
  "bf-antiinflamatorio"
 ],
 "inflamaciones": [
  "bf-antiinflamatorio"
 ],
 "inflamada": [
  "bf-antiinflamatorio"
 ],
 "inflamado": [
  "bf-antiinflamatorio"
 ],
 "inflamatoria": [
  "bf-antiinflamatorio"
 ],
 "inflamatorio": [
  "bf-antiinflamatorio"
 ],
 "infusiones": [
  "bf-sin-cafeina"
 ],
 "inmune": [
  "bf-defensas"
 ],
 "inmunidad": [
  "bf-defensas"
 ],
 "inmunitario": [
  "bf-defensas"
 ],
 "inmunoestimulante": [
  "bf-defensas"
 ],
 "inmunologico": [
  "bf-defensas"
 ],
 "insolacion": [
  "bf-hidratacion"
 ],
 "insomnio": [
  "bf-sueno"
 ],
 "insulina": [
  "bf-glucosa"
 ],
 "intoxicada": [
  "bf-depurativo"
 ],
 "intoxicado": [
  "bf-depurativo"
 ],
 "irritabilidad": [
  "bf-relax"
 ],
 "isoflavona": [
  "bf-menopausia"
 ],
 "isoflavonas": [
  "bf-menopausia"
 ],
 "isotonica": [
  "bf-hidratacion"
 ],
 "isotonicas": [
  "bf-hidratacion"
 ],
 "isotonico": [
  "bf-hidratacion"
 ],
 "jengibre": [
  "bf-defensas",
  "bf-respiratorio"
 ],
 "jovial": [
  "bf-animo"
 ],
 "jubilada": [
  "bf-senior"
 ],
 "jubilado": [
  "bf-senior"
 ],
 "jubilados": [
  "bf-senior"
 ],
 "lactancia": [
  "bf-embarazo"
 ],
 "lactante": [
  "bf-embarazo"
 ],
 "lactantes": [
  "bf-infantil"
 ],
 "lagrimas": [
  "bf-vista"
 ],
 "lagrimeo": [
  "bf-vista"
 ],
 "laringitis": [
  "bf-respiratorio"
 ],
 "lavanda": [
  "bf-relax"
 ],
 "laxante": [
  "bf-transito"
 ],
 "laxantes": [
  "bf-transito"
 ],
 "ldl": [
  "bf-colesterol"
 ],
 "letargo": [
  "bf-energia"
 ],
 "levotiroxina": [
  "bf-tiroides"
 ],
 "libido": [
  "bf-libido"
 ],
 "linfatica": [
  "bf-circulacion"
 ],
 "linfatico": [
  "bf-circulacion"
 ],
 "lipidos": [
  "bf-colesterol"
 ],
 "lipolisis": [
  "bf-metabolismo"
 ],
 "lipoproteina": [
  "bf-colesterol"
 ],
 "lipoproteinas": [
  "bf-colesterol"
 ],
 "liquidos": [
  "bf-diuretico"
 ],
 "litiasis": [
  "bf-vias-urinarias"
 ],
 "longevidad": [
  "bf-antiedad",
  "bf-senior"
 ],
 "lucidez": [
  "bf-concentracion"
 ],
 "luminosidad": [
  "bf-piel"
 ],
 "lupulo": [
  "bf-sueno",
  "bf-relax"
 ],
 "macula": [
  "bf-vista"
 ],
 "madrugon": [
  "bf-sueno"
 ],
 "malvavisco": [
  "bf-respiratorio"
 ],
 "maraton": [
  "bf-deporte"
 ],
 "mareo": [
  "bf-nauseas"
 ],
 "mareos": [
  "bf-nauseas"
 ],
 "mate": [
  "bf-estimulante"
 ],
 "maternidad": [
  "bf-embarazo"
 ],
 "mayores": [
  "bf-senior"
 ],
 "meada": [
  "bf-diuretico"
 ],
 "meadas": [
  "bf-diuretico"
 ],
 "melancolia": [
  "bf-animo"
 ],
 "melancolica": [
  "bf-animo"
 ],
 "melancolico": [
  "bf-animo"
 ],
 "melatonina": [
  "bf-sueno"
 ],
 "melisa": [
  "bf-relax",
  "bf-sueno"
 ],
 "memoria": [
  "bf-concentracion",
  "omega-3"
 ],
 "menarquia": [
  "bf-menstruacion"
 ],
 "menopausia": [
  "bf-menopausia"
 ],
 "menopausica": [
  "bf-menopausia"
 ],
 "menopausico": [
  "bf-menopausia"
 ],
 "menorragia": [
  "bf-menstruacion"
 ],
 "menstruacion": [
  "bf-menstruacion"
 ],
 "menstrual": [
  "bf-menstruacion"
 ],
 "menstruales": [
  "bf-menstruacion"
 ],
 "metabolismo": [
  "bf-metabolismo"
 ],
 "meteorismo": [
  "bf-gases"
 ],
 "metrorragia": [
  "bf-menstruacion"
 ],
 "mialgia": [
  "bf-musculo"
 ],
 "mialgias": [
  "bf-musculo"
 ],
 "miccion": [
  "bf-diuretico"
 ],
 "miccional": [
  "bf-prostata"
 ],
 "microbicida": [
  "bf-antibacteriano"
 ],
 "microbios": [
  "bf-antibacteriano"
 ],
 "microbiota": [
  "bf-microbiota"
 ],
 "microcirculacion": [
  "bf-circulacion"
 ],
 "mineralizacion": [
  "bf-huesos"
 ],
 "miopia": [
  "bf-vista"
 ],
 "mocos": [
  "bf-respiratorio"
 ],
 "motivacion": [
  "bf-animo"
 ],
 "mucosidad": [
  "bf-respiratorio"
 ],
 "mucosidades": [
  "bf-respiratorio"
 ],
 "musculacion": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "musculatura": [
  "bf-musculo"
 ],
 "musculo": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "musculos": [
  "bf-musculo"
 ],
 "nasal": [
  "bf-respiratorio"
 ],
 "nauseas": [
  "bf-nauseas"
 ],
 "nefritis": [
  "bf-vias-urinarias"
 ],
 "nefropatia": [
  "bf-vias-urinarias"
 ],
 "nerbios": [
  "bf-relax"
 ],
 "nervios": [
  "bf-relax"
 ],
 "nerviosa": [
  "bf-relax"
 ],
 "nerviosismo": [
  "bf-relax"
 ],
 "nervioso": [
  "bf-relax"
 ],
 "nicturia": [
  "bf-prostata"
 ],
 "nina": [
  "bf-infantil"
 ],
 "nino": [
  "bf-infantil"
 ],
 "ninos": [
  "bf-infantil"
 ],
 "nocturno": [
  "bf-sueno"
 ],
 "nootropico": [
  "bf-concentracion"
 ],
 "obesidad": [
  "bf-metabolismo"
 ],
 "ocular": [
  "bf-vista"
 ],
 "oculares": [
  "bf-vista"
 ],
 "oftalmica": [
  "bf-vista"
 ],
 "oftalmico": [
  "bf-vista"
 ],
 "ojeras": [
  "bf-piel"
 ],
 "ojos": [
  "bf-vista"
 ],
 "oligomenorrea": [
  "bf-menstruacion"
 ],
 "olvidos": [
  "bf-concentracion"
 ],
 "optimismo": [
  "bf-animo"
 ],
 "orina": [
  "bf-diuretico"
 ],
 "orinar": [
  "bf-diuretico"
 ],
 "orinaria": [
  "bf-diuretico",
  "bf-vias-urinarias"
 ],
 "orinas": [
  "bf-vias-urinarias"
 ],
 "osea": [
  "bf-huesos"
 ],
 "oseo": [
  "bf-huesos"
 ],
 "osteoarticular": [
  "bf-huesos",
  "bf-articulaciones"
 ],
 "osteoarticulares": [
  "bf-huesos",
  "bf-articulaciones"
 ],
 "osteomalacia": [
  "bf-huesos"
 ],
 "osteopenia": [
  "bf-huesos"
 ],
 "osteoporosis": [
  "bf-huesos",
  "calcio"
 ],
 "ovarico": [
  "bf-menopausia"
 ],
 "oxidacion": [
  "bf-antioxidante"
 ],
 "oxidantes": [
  "bf-antioxidante"
 ],
 "oxidativa": [
  "bf-antioxidante"
 ],
 "oxidativo": [
  "bf-antioxidante"
 ],
 "pachucha": [
  "bf-energia"
 ],
 "pachucho": [
  "bf-energia"
 ],
 "palpitaciones": [
  "bf-corazon"
 ],
 "parvulos": [
  "bf-infantil"
 ],
 "pasiflora": [
  "bf-relax",
  "bf-sueno"
 ],
 "patogenos": [
  "bf-antibacteriano"
 ],
 "pediatrico": [
  "bf-infantil"
 ],
 "peke": [
  "bf-infantil"
 ],
 "pelo": [
  "bf-pelo-unas"
 ],
 "peque": [
  "bf-infantil"
 ],
 "peques": [
  "bf-infantil"
 ],
 "perimenopausia": [
  "bf-menopausia"
 ],
 "pesadez": [
  "bf-digestion"
 ],
 "pesadilla": [
  "bf-sueno"
 ],
 "pesadillas": [
  "bf-sueno"
 ],
 "picor": [
  "bf-vias-urinarias"
 ],
 "picotear": [
  "bf-saciedad"
 ],
 "picoteo": [
  "bf-saciedad"
 ],
 "piel": [
  "bf-piel"
 ],
 "pielonefritis": [
  "bf-vias-urinarias"
 ],
 "pilates": [
  "bf-deporte"
 ],
 "pino": [
  "bf-respiratorio"
 ],
 "pipi": [
  "bf-diuretico"
 ],
 "pirosis": [
  "bf-acidez"
 ],
 "polaquiuria": [
  "bf-vias-urinarias"
 ],
 "polifenoles": [
  "bf-antioxidante"
 ],
 "poliuria": [
  "bf-diuretico"
 ],
 "poros": [
  "bf-piel"
 ],
 "positividad": [
  "bf-animo"
 ],
 "posparto": [
  "bf-embarazo"
 ],
 "postentreno": [
  "bf-deporte",
  "bf-musculo"
 ],
 "prebiotico": [
  "bf-microbiota"
 ],
 "prebioticos": [
  "bf-microbiota"
 ],
 "precordial": [
  "bf-corazon"
 ],
 "prediabetes": [
  "bf-glucosa"
 ],
 "preentreno": [
  "bf-deporte"
 ],
 "premenopausia": [
  "bf-menopausia"
 ],
 "premenstrual": [
  "bf-menstruacion"
 ],
 "prenatal": [
  "bf-embarazo"
 ],
 "prenatales": [
  "bf-embarazo"
 ],
 "presbicia": [
  "bf-vista"
 ],
 "presion": [
  "bf-tension"
 ],
 "probiotico": [
  "bf-microbiota"
 ],
 "probioticos": [
  "bf-microbiota"
 ],
 "propoleo": [
  "bf-antibacteriano",
  "bf-defensas"
 ],
 "prostata": [
  "bf-prostata"
 ],
 "prostatectomia": [
  "bf-prostata"
 ],
 "prostatica": [
  "bf-prostata"
 ],
 "prostatico": [
  "bf-prostata"
 ],
 "prostatismo": [
  "bf-prostata"
 ],
 "prostatitis": [
  "bf-prostata"
 ],
 "proteina": [
  "alto-en-proteina",
  "bf-musculo"
 ],
 "psa": [
  "bf-prostata"
 ],
 "psoriasis": [
  "bf-piel"
 ],
 "puerperal": [
  "bf-embarazo"
 ],
 "puerperio": [
  "bf-embarazo"
 ],
 "purgante": [
  "bf-transito"
 ],
 "purgativo": [
  "bf-depurativo"
 ],
 "purificacion": [
  "bf-depurativo"
 ],
 "purificante": [
  "bf-depurativo"
 ],
 "purificar": [
  "bf-depurativo"
 ],
 "quebradizas": [
  "bf-pelo-unas"
 ],
 "quebradizo": [
  "bf-pelo-unas"
 ],
 "quemada": [
  "bf-relax"
 ],
 "quemado": [
  "bf-relax"
 ],
 "quemagrasa": [
  "bf-metabolismo"
 ],
 "quemagrasas": [
  "bf-metabolismo"
 ],
 "queratina": [
  "bf-pelo-unas"
 ],
 "radicales": [
  "bf-antioxidante"
 ],
 "raquitismo": [
  "bf-huesos"
 ],
 "reconstituyente": [
  "bf-estimulante"
 ],
 "reflujo": [
  "bf-acidez"
 ],
 "refuerzo": [
  "bf-defensas"
 ],
 "regaliz": [
  "bf-respiratorio"
 ],
 "regla": [
  "bf-menstruacion"
 ],
 "reglas": [
  "bf-menstruacion"
 ],
 "regularidad": [
  "bf-transito"
 ],
 "rehidratacion": [
  "bf-hidratacion"
 ],
 "rehidratante": [
  "bf-hidratacion"
 ],
 "rejuvenecer": [
  "bf-antiedad"
 ],
 "rejuvenecimiento": [
  "bf-antiedad"
 ],
 "relajacion": [
  "bf-relax"
 ],
 "relajante": [
  "bf-relax"
 ],
 "relajarme": [
  "bf-relax"
 ],
 "relajarse": [
  "bf-relax"
 ],
 "renal": [
  "bf-vias-urinarias"
 ],
 "renales": [
  "bf-vias-urinarias"
 ],
 "rendimiento": [
  "bf-deporte"
 ],
 "resaca": [
  "bf-depurativo",
  "bf-nauseas"
 ],
 "resfriado": [
  "bf-respiratorio",
  "bf-defensas"
 ],
 "resfriados": [
  "bf-defensas"
 ],
 "resfriao": [
  "bf-defensas"
 ],
 "resfrio": [
  "bf-defensas"
 ],
 "resollar": [
  "bf-respiratorio"
 ],
 "respiratorio": [
  "bf-respiratorio"
 ],
 "resveratrol": [
  "bf-antioxidante"
 ],
 "retina": [
  "bf-vista"
 ],
 "reuma": [
  "bf-articulaciones"
 ],
 "reumatismo": [
  "bf-articulaciones"
 ],
 "rigidez": [
  "bf-articulaciones"
 ],
 "rinitis": [
  "bf-respiratorio"
 ],
 "rinon": [
  "bf-diuretico",
  "bf-vias-urinarias"
 ],
 "rinones": [
  "bf-vias-urinarias"
 ],
 "rodilla": [
  "bf-articulaciones"
 ],
 "rodillas": [
  "bf-articulaciones"
 ],
 "rodiola": [
  "bf-estimulante",
  "bf-animo"
 ],
 "rojeces": [
  "bf-piel"
 ],
 "ronquera": [
  "bf-respiratorio"
 ],
 "rosacea": [
  "bf-piel"
 ],
 "running": [
  "bf-deporte"
 ],
 "sabanones": [
  "bf-circulacion"
 ],
 "saciante": [
  "bf-saciedad",
  "fibra"
 ],
 "saciedad": [
  "bf-saciedad"
 ],
 "sales": [
  "bf-hidratacion"
 ],
 "sarcopenia": [
  "bf-musculo",
  "alto-en-proteina"
 ],
 "saturada": [
  "bf-relax"
 ],
 "saturado": [
  "bf-relax"
 ],
 "sauco": [
  "bf-defensas",
  "bf-respiratorio"
 ],
 "seborrea": [
  "bf-piel"
 ],
 "sed": [
  "bf-hidratacion"
 ],
 "sedante": [
  "bf-relax"
 ],
 "sedentarismo": [
  "bf-metabolismo"
 ],
 "senior": [
  "bf-senior"
 ],
 "siesta": [
  "bf-sueno"
 ],
 "silbido": [
  "bf-respiratorio"
 ],
 "simbiotico": [
  "bf-microbiota"
 ],
 "simbioticos": [
  "bf-microbiota"
 ],
 "sinusitis": [
  "bf-respiratorio"
 ],
 "sistolica": [
  "bf-tension"
 ],
 "sobrepasado": [
  "bf-relax"
 ],
 "sobrepeso": [
  "bf-metabolismo"
 ],
 "sofoco": [
  "bf-menopausia"
 ],
 "sofocos": [
  "bf-menopausia"
 ],
 "somnifero": [
  "bf-sueno"
 ],
 "somnolencia": [
  "bf-energia"
 ],
 "sop": [
  "bf-menstruacion"
 ],
 "spinning": [
  "bf-deporte"
 ],
 "sueno": [
  "bf-sueno"
 ],
 "t3": [
  "bf-tiroides"
 ],
 "t4": [
  "bf-tiroides"
 ],
 "taquicardia": [
  "bf-corazon"
 ],
 "teina": [
  "bf-estimulante"
 ],
 "tendinitis": [
  "bf-articulaciones"
 ],
 "tensa": [
  "bf-relax"
 ],
 "tensiometro": [
  "bf-tension"
 ],
 "tension": [
  "bf-tension",
  "bf-relax"
 ],
 "tensional": [
  "bf-tension"
 ],
 "tensiones": [
  "bf-tension"
 ],
 "tenso": [
  "bf-relax"
 ],
 "termogenico": [
  "bf-metabolismo"
 ],
 "testosterona": [
  "bf-libido"
 ],
 "tila": [
  "bf-relax"
 ],
 "tiroidea": [
  "bf-tiroides"
 ],
 "tiroidectomia": [
  "bf-tiroides"
 ],
 "tiroideo": [
  "bf-tiroides"
 ],
 "tiroides": [
  "bf-tiroides",
  "yodo",
  "bf-metabolismo"
 ],
 "tiroiditis": [
  "bf-tiroides"
 ],
 "tomillo": [
  "bf-respiratorio",
  "bf-antibacteriano"
 ],
 "tonificante": [
  "bf-musculo"
 ],
 "tonificar": [
  "bf-musculo"
 ],
 "toronjil": [
  "bf-relax",
  "bf-sueno"
 ],
 "tos": [
  "bf-respiratorio"
 ],
 "toser": [
  "bf-respiratorio"
 ],
 "tosiendo": [
  "bf-respiratorio"
 ],
 "toxica": [
  "bf-depurativo"
 ],
 "toxico": [
  "bf-depurativo"
 ],
 "toxinas": [
  "bf-depurativo"
 ],
 "tranquilizante": [
  "bf-relax"
 ],
 "transito": [
  "bf-transito"
 ],
 "trasnochar": [
  "bf-sueno"
 ],
 "triatlon": [
  "bf-deporte"
 ],
 "tricologico": [
  "bf-pelo-unas"
 ],
 "triglicerido": [
  "bf-colesterol"
 ],
 "trigliceridos": [
  "bf-colesterol"
 ],
 "trimestre": [
  "bf-embarazo"
 ],
 "tristeza": [
  "bf-animo"
 ],
 "trizteza": [
  "bf-animo"
 ],
 "trombosis": [
  "bf-circulacion"
 ],
 "tsh": [
  "bf-tiroides"
 ],
 "unas": [
  "bf-pelo-unas"
 ],
 "uretra": [
  "bf-vias-urinarias"
 ],
 "uretritis": [
  "bf-vias-urinarias"
 ],
 "urinaria": [
  "bf-vias-urinarias"
 ],
 "urinarias": [
  "bf-vias-urinarias"
 ],
 "urinario": [
  "bf-vias-urinarias"
 ],
 "urologia": [
  "bf-prostata"
 ],
 "urologo": [
  "bf-prostata"
 ],
 "valeriana": [
  "bf-sueno",
  "bf-relax"
 ],
 "varice": [
  "bf-circulacion"
 ],
 "varices": [
  "bf-circulacion"
 ],
 "varicosa": [
  "bf-circulacion"
 ],
 "varicosas": [
  "bf-circulacion"
 ],
 "varicoso": [
  "bf-circulacion"
 ],
 "vasculares": [
  "bf-circulacion"
 ],
 "vasoconstriccion": [
  "bf-circulacion"
 ],
 "vasodilatador": [
  "bf-circulacion"
 ],
 "vasomotor": [
  "bf-menopausia"
 ],
 "vasomotores": [
  "bf-menopausia"
 ],
 "vejez": [
  "bf-senior"
 ],
 "vejiga": [
  "bf-vias-urinarias"
 ],
 "vena": [
  "bf-circulacion"
 ],
 "venas": [
  "bf-circulacion"
 ],
 "ventosidades": [
  "bf-gases"
 ],
 "verbena": [
  "bf-relax"
 ],
 "vesical": [
  "bf-vias-urinarias"
 ],
 "vientre": [
  "bf-transito"
 ],
 "vigilia": [
  "bf-estimulante"
 ],
 "vigor": [
  "bf-energia"
 ],
 "viral": [
  "bf-defensas"
 ],
 "virico": [
  "bf-defensas"
 ],
 "virilidad": [
  "bf-libido"
 ],
 "virus": [
  "bf-defensas"
 ],
 "vision": [
  "bf-vista"
 ],
 "vista": [
  "bf-vista"
 ],
 "vitalidad": [
  "bf-energia"
 ],
 "vomitar": [
  "bf-nauseas"
 ],
 "vomito": [
  "bf-nauseas"
 ],
 "vomitos": [
  "bf-nauseas"
 ],
 "voracidad": [
  "bf-saciedad"
 ],
 "yodada": [
  "bf-tiroides",
  "yodo"
 ],
 "yodado": [
  "bf-tiroides",
  "yodo"
 ],
 "yodo": [
  "bf-tiroides",
  "yodo"
 ]
}
};
